<template>
  <v-container>
    <v-row class="flex-column justify-start pa-2" dense>
      <v-flex
        v-if="
          this.$store.getters.currentUser.infosClientJDE.coteABCAgent == null
        "
        pb-5
      >
        <div class="texteMessageErreur">
          Vous devez avoir une catégorie de dépôt pour effectuer une demande.
        </div>
        <div class="texteMessageErreur">
          Le paramétrage de votre compte est incomplet, veuillez contacter le
          Service des importations privées pour plus de détails.
        </div>
        <div class="texteMessageErreur">
          Téléphone: (514)254-6000 poste 5903
        </div>
      </v-flex>

      <v-flex
        v-if="capaciteFinanciere.montantCapacite <= Number(0)"
        class="texteMessageErreur"
        md12
        mb-5
      >
        Vous n'êtes pas autorisé à effectuer une demande d'importation privée et
        ce, en raison de l'absence d'un montant à votre capacité financière,
        Veuillez accéder à la section "Capacité financière" pour ajouter une
        somme ou pour plus de détails, veuillez communiquer avec le service des
        importations privées au (514) 254-6000 poste 5903</v-flex
      >

      <v-stepper>
        <v-stepper-header>
          <v-stepper-step step="1" editable>Fournisseur</v-stepper-step>
          <v-stepper-step step="2" editable>Produits</v-stepper-step>
          <v-stepper-step step="3" editable>Récapitulatif</v-stepper-step>
          <v-stepper-step
            v-if="$store.getters.currentUser.clientData.indComptant == true"
            step="4"
            editable
            @click="initCarteCredit"
            >Paiement</v-stepper-step
          >

          <v-divider />
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <!-- ------ ------->
            <!-- Fournisseur -->
            <!-- ------ ------->
            <stepFournisseur />

            <v-btn
              medium
              color="primary"
              style="text-transform: none;"
              class="ml-10"
              @click="annuler()"
            >
              Annuler
            </v-btn>
          </v-stepper-content>

          <v-stepper-content step="2">
            <!-- ---------------- -->
            <!--   ajout produit  -->
            <!-- ---------------- -->

            <v-layout>
              <v-flex xs12>
                <v-row>
                  <v-col
                    v-if="afficherAjoutProduit == false"
                    cols="4"
                    sm="4"
                    class="pa-0 pl-3"
                  >
                    <v-btn
                      dark
                      small
                      text
                      color="primary"
                      @click="ajoutProduit()"
                    >
                      Ajouter un produit
                    </v-btn>
                  </v-col>

                  <v-col
                    v-if="afficherAjoutProduit == true"
                    cols="5"
                    sm="5"
                    class="pa-0 pl-3"
                  >
                    <v-btn
                      dark
                      small
                      text
                      color="primary"
                      @click="annulerAjoutProduit()"
                    >
                      Annuler
                    </v-btn>
                  </v-col>
                </v-row>
              </v-flex>
            </v-layout>

            <v-flex xs2 pb-5>
              <div v-if="afficherAjoutProduit == false" class="pt-2"></div>
            </v-flex>

            <v-data-table
              v-if="afficherAjoutProduit == false"
              :headers="headers"
              :items="demandeData.listeDemandeLigneData"
              hide-default-footer
              dense
              disable-pagination
            >
              <template v-slot:item.description="{ item }">
                <span style="font-size: 12px">
                  {{ item.description }}
                </span>
              </template>

              <template
                v-slot:item.infoProduitMatrice.paysOrigine.fr="{ item }"
              >
                <span style="font-size: 12px">
                  {{ item.infoProduitMatrice.paysOrigine.fr }}
                </span>
              </template>

              <template v-slot:item.uvc="{ item }">
                <span style="font-size: 12px"
                  >{{ item.uvc }} x {{ item.formatBtl }}
                  {{ formatBouteille.get(item.uniteMesure) }}</span
                >
              </template>

              <template v-slot:item.nombreCaissesDemandees="{ item }">
                <v-text-field
                  v-model.trim="item.nombreCaissesDemandees"
                  class="pt-5"
                  single-line
                  dense
                  outlined
                  @change="modifierNombreCaisse(item)"
                />
              </template>

              <template v-slot:item.prixFournisseur="{ item }">
                <span style="font-size: 12px">
                  {{ $fmtDecimal(item.prixFournisseur) }}
                </span>
              </template>

              <template v-slot:item.prixDetail="{ item }">
                <span style="font-size: 12px">
                  {{ $fmtDecimal(item.prixDetail) }} $
                </span>
              </template>

              <template v-slot:item.montantCalcule="{ item }">
                <span style="font-size: 12px">
                  {{ $fmtDecimal(item.montantCalcule) }} $
                  {{ devise.get(item.devise) }}
                </span>
              </template>

              <template v-slot:item.montantCalculeCAD="{ item }">
                <span style="font-size: 12px">
                  {{ $fmtDecimal(item.montantCalculeCAD) }} $
                </span>
              </template>

              <template v-slot:item.montantDepotAVerser="{ item }">
                <span style="font-size: 12px">
                  {{ $fmtDecimal(item.montantDepotAVerser) }} $
                </span>
              </template>

              <template v-slot:item.actionAfficherInfo="props">
                <v-icon
                  medium
                  class="mr-2"
                  color="accent"
                  @click="afficherInfosComplementaire(props.item)"
                >
                  list_alt
                </v-icon>
              </template>

              <!-- ------- -->
              <!-- Actions -->
              <!-- -------- -->
              <template
                v-slot:item.action="{ item }"
                class="d-flex justify-center"
              >
                <v-icon
                  medium
                  class="mr-2"
                  color="accent"
                  @click="modifierProduit(item)"
                >
                  edit
                </v-icon>
                <v-icon
                  medium
                  class="mr-2"
                  color="accent"
                  @click="supprimerProduit(item)"
                >
                  delete
                </v-icon>
              </template>
            </v-data-table>

            <v-dialog
              v-model="dialogInfoProduit"
              :retain-focus="false"
              width="500"
            >
              <v-card>
                <v-card-title class="grey lighten-3">
                  Informations produits
                </v-card-title>

                <v-divider />

                <div class="pl-8 pt-5">
                  <span class="pr-5" style="font-weight: bold"
                    >Nom du producteur:
                  </span>
                  <span class="pl-7">{{
                    infosComplementaire.nomProducteur
                  }}</span>
                </div>

                <div class="pl-8 pt-1">
                  <span class="pr-5" style="font-weight: bold"
                    >Marque commerciale:</span
                  >
                  <span class="pl-5">{{
                    infosComplementaire.marqueCommerciale
                  }}</span>
                </div>

                <div class="pl-8 pt-1">
                  <span class="pr-7" style="font-weight: bold"
                    >Nom de la cuvée:</span
                  >
                  <span class="pl-10">{{ infosComplementaire.nomCuvee }}</span>
                </div>

                <div
                  v-if="infosComplementaire.infoProduitMatrice.nature != null"
                  class="pl-8 pt-1"
                >
                  <span class="pr-15" style="font-weight: bold">Nature:</span>
                  <span class="pl-16">
                    {{ infosComplementaire.infoProduitMatrice.nature.fr }}</span
                  >
                </div>

                <div
                  v-if="infosComplementaire.infoProduitMatrice.famille != null"
                  class="pl-8 pt-1"
                >
                  <span class="pr-14" style="font-weight: bold">Famille:</span>
                  <span class="pl-16">{{
                    infosComplementaire.infoProduitMatrice.famille.fr
                  }}</span>
                </div>

                <div
                  v-if="infosComplementaire.infoProduitMatrice.type != null"
                  class="pl-8 pt-1"
                >
                  <span class="pr-16" style="font-weight: bold">Type:</span>
                  <span class="pl-16">{{
                    infosComplementaire.infoProduitMatrice.type.fr
                  }}</span>
                </div>

                <div
                  v-if="
                    infosComplementaire.infoProduitMatrice.paysOrigine != null
                  "
                  class="pl-8 pt-1"
                >
                  <span class="pr-10" style="font-weight: bold"
                    >Pays d'origine:</span
                  >
                  <span class="pl-10">{{
                    infosComplementaire.infoProduitMatrice.paysOrigine.fr
                  }}</span>
                </div>

                <div
                  v-if="
                    infosComplementaire.infoProduitMatrice.regionOrigine != null
                  "
                  class="pl-8 pt-1"
                >
                  <span class="pr-14" style="font-weight: bold">Région:</span>
                  <span class="pl-15">{{
                    infosComplementaire.infoProduitMatrice.regionOrigine.fr
                  }}</span>
                </div>

                <div
                  v-if="
                    infosComplementaire.infoProduitMatrice.sousRegionOrigine !=
                      null
                  "
                  class="pl-8 pt-1"
                >
                  <span class="pr-12" style="font-weight: bold"
                    >Sous-région:</span
                  >
                  <span class="pl-10">{{
                    infosComplementaire.infoProduitMatrice.sousRegionOrigine.fr
                  }}</span>
                </div>

                <div
                  v-if="infosComplementaire.infoProduitMatrice.couleur != null"
                  class="pl-8 pt-1"
                >
                  <span class="pr-13" style="font-weight: bold">Couleur:</span>
                  <span class="pl-15">{{
                    infosComplementaire.infoProduitMatrice.couleur.fr
                  }}</span>
                </div>

                <div class="pl-8 pt-1">
                  <span class="pr-12" style="font-weight: bold">Cépage1:</span>
                  <span class="pl-15">{{ infosComplementaire.cepage1 }}</span>
                </div>

                <div class="pl-8 pt-1">
                  <span class="pr-12" style="font-weight: bold">Cépage2:</span>
                  <span class="pl-15">{{ infosComplementaire.cepage2 }}</span>
                </div>

                <div class="pl-8 pt-1">
                  <span class="pr-16" style="font-weight: bold">CUP:</span>
                  <span class="pl-16">{{ infosComplementaire.cup }}</span>
                </div>

                <div class="pl-8 pt-1">
                  <span class="mr-16" style="font-weight: bold">SCC:</span>
                  <span class="ml-16">{{ infosComplementaire.scc }}</span>
                </div>

                <div class="pl-8 pt-1">
                  <span class="pr-5" style="font-weight: bold"
                    >Pourcentage d'alcool:</span
                  >
                  <span class="pl-5"
                    >{{ infosComplementaire.pourcentageAlcool }} %</span
                  >
                </div>

                <div class="pl-8 pt-1">
                  <span class="pr-7" style="font-weight: bold"
                    >Millésime / âge:</span
                  >
                  <span class="pl-10">{{ infosComplementaire.millesime }}</span>
                </div>

                <div class="pl-8 pt-1">
                  <span class="pr-10" style="font-weight: bold"
                    >Type de contenant:</span
                  >
                  <span class="pl-2">
                    {{
                      listeTypeContenants.get(infosComplementaire.typeContenant)
                    }}</span
                  >
                </div>

                <div class="pl-8 pt-1 pb-5">
                  <span class="pr-5" style="font-weight: bold"
                    >Type de bouchon:</span
                  >
                  <span class="pl-10">{{
                    listeTypeBouchons.get(infosComplementaire.typeBouchon)
                  }}</span>
                </div>

                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    color="primary"
                    text
                    @click="dialogInfoProduit = false"
                  >
                    Fermer
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <div
              v-if="demandeData.montantTotalCAD != null"
              class="pl-5 pt-2"
              style="font-weight: bold"
            >
              *UVC : nombre de bouteilles dans une caisse
            </div>
            <div
              v-if="
                (afficherAjoutProduit == false &&
                  this.$store.getters.currentUser.clientData.typeClient ==
                    'TITULAIRE_POUR_REVENTE') ||
                  this.$store.getters.currentUser.clientData.typeClient ==
                    'BOUTIQUE_HORS_TAXE'
              "
              class="pl-5"
              style="font-weight: bold"
            >
              **Les taxes sont exclues du prix de vente estimé par bouteille.
            </div>

            <!-- ------ -->
            <!-- Totaux -->
            <!-- ------ -->

            <table
              v-if="afficherAjoutProduit == false"
              class="pl-10 pt-5 pb-10"
              style="font-weight: bold"
            >
              <tr>
                <td style="width: 200px"></td>
                <td style="width: 500px"></td>
                <td style="width: 100px; text-align: right">Total :</td>
                <td style="width: 100px; text-align: right">
                  {{ $fmtDecimal(demandeData.montantTotalCAD) }} $
                </td>
                <td style="width: 250px"></td>
                <td style="width: 400px">
                  {{ $fmtDecimal(demandeData.montantTotalDepot) }} $
                </td>
              </tr>

              <tr>
                <td style="width: 200px"></td>
                <td style="width: 300px"></td>
                <td style="width: 200px; text-align: right">
                  TOTAL À PAYER :
                </td>
                <td style="width: 100px; text-align: right">
                  {{ $fmtDecimal(demandeData.montantTotalCAD) }} $
                </td>
                <td style="width: 250px"></td>
                <td style="width: 350px">
                  {{ $fmtDecimal(demandeData.montantTotalDepot) }} $
                </td>
              </tr>
            </table>

            <v-card
              v-if="afficherAjoutProduit == true"
              style="font-size: 14px; color: black;"
            >
              <v-col cols="12" sm="8" class="pa-0 pb-5">
                <v-select
                  v-model="produitSelect"
                  :items="this.$store.getters.demande.listeProduits"
                  :disabled="produitReconduction"
                  label="Rechercher un produit selon le fournisseur sélectionné"
                  item-text="0"
                  item-value="1"
                  class="text-caption pa-0"
                  dense
                  height="40"
                  prepend-icon="mdi-database-search"
                  single-line
                  hide-no-data
                  @change="selectionnerProduit"
                >
                  <template v-slot:selection="data">
                    <span>
                      {{ data.item.noProduitJDE }} {{ data.item.description }}
                      {{ data.item.noFournisseur }}
                      {{ data.item.nomFournisseur }}</span
                    >
                  </template>
                  <template v-slot:item="data">
                    <span>
                      {{ data.item.noProduitJDE }} {{ data.item.description }}
                      {{ data.item.noFournisseur }}
                      {{ data.item.nomFournisseur }}</span
                    >
                  </template>
                </v-select>
              </v-col>
              <v-layout>
                <v-flex md3 pt-1> * Nom du producteur </v-flex>
                <v-flex md5>
                  <v-text-field
                    v-model.trim="nomProducteur"
                    :readonly="produitReconduction"
                    style="color: black;"
                    single-line
                    dense
                    outlined
                  />
                </v-flex>
              </v-layout>

              <v-layout>
                <v-flex md3 pt-1> * Marque commerciale </v-flex>
                <v-flex md5>
                  <v-text-field
                    v-model.trim="marqueCommerciale"
                    :readonly="produitReconduction"
                    class="pa-0"
                    style="color: black;"
                    single-line
                    dense
                    outlined
                    @change="majNomProduit()"
                  />
                </v-flex>
              </v-layout>

              <v-layout>
                <v-flex md3 pt-1> Nom de la cuvée </v-flex>
                <v-flex md5>
                  <v-text-field
                    v-model.trim="nomCuvee"
                    :readonly="produitReconduction"
                    class="pa-0"
                    style="color: black;"
                    single-line
                    dense
                    outlined
                    @change="majNomProduit()"
                  />
                </v-flex>
              </v-layout>

              <v-layout>
                <v-flex md3 pt-1> * Nom du produit </v-flex>
                <v-flex md5>
                  <v-text-field
                    v-model.trim="description"
                    :readonly="produitReconduction"
                    class="pa-0"
                    style="color: black;"
                    single-line
                    dense
                    outlined
                  />
                </v-flex>
              </v-layout>

              <v-layout>
                <v-flex md3 pt-1> * Nature </v-flex>

                <v-flex md3>
                  <v-select
                    v-model="natureSelectionne"
                    :items="listeNature"
                    :readonly="produitReconduction"
                    label="Sélectionnez"
                    item-text="0"
                    item-value="1"
                    class="text-caption pa-0"
                    style="color: black;"
                    dense
                    height="40"
                    single-line
                    hide-no-data
                    @change="obtenirListeFamilleSelonNature()"
                  >
                    <template v-slot:selection="data">
                      {{ data.item.natureFamilleType.fr }}
                    </template>
                    <template v-slot:item="data">
                      {{ data.item.natureFamilleType.fr }}
                    </template>
                  </v-select>
                </v-flex>
              </v-layout>

              <v-layout>
                <v-flex md3 pt-1> * Famille </v-flex>

                <v-flex md3>
                  <v-select
                    v-model="familleSelectionne"
                    :items="listeFamille"
                    :readonly="produitReconduction"
                    label="Sélectionnez"
                    item-text="0"
                    item-value="1"
                    class="text-caption pa-0"
                    style="color: black;"
                    dense
                    height="40"
                    single-line
                    hide-no-data
                    @change="obtenirTypeSelonFamille()"
                  >
                    <template v-slot:selection="data">
                      {{ data.item.natureFamilleType.fr }}
                    </template>
                    <template v-slot:item="data">
                      {{ data.item.natureFamilleType.fr }}
                    </template>
                  </v-select>
                </v-flex>
              </v-layout>

              <v-layout>
                <v-flex md3 pt-1> Type </v-flex>

                <v-flex md3>
                  <v-select
                    v-model="typeSelectionne"
                    :disabled="listeType.length == 0"
                    :items="listeType"
                    :readonly="produitReconduction"
                    label="Sélectionnez"
                    item-value="1"
                    item-text="0"
                    class="text-caption pa-0"
                    style="color: black;"
                    dense
                    height="40"
                    single-line
                    hide-no-data
                  >
                    <template v-slot:selection="data">
                      {{ data.item.natureFamilleType.fr }}
                    </template>
                    <template v-slot:item="data">
                      {{ data.item.natureFamilleType.fr }}
                    </template>
                  </v-select>
                </v-flex>
              </v-layout>

              <v-layout pt-3 pb-3>
                <v-flex md3> * Pays d'origine </v-flex>

                <v-flex
                  v-if="
                    paysSelectionne.paysRegion != null &&
                      paysSelectionne.paysRegion.code == null
                  "
                  md3
                >
                  <v-autocomplete
                    v-model.trim="paysSelectionne"
                    :items="listePaysFrequents"
                    :readonly="produitReconduction"
                    item-value="paysRegion.code"
                    :item-text="item => item.paysRegion.fr"
                    class="text-caption pa-0 ma-0"
                    style="color: black;"
                    label="Sélectionnez"
                    dense
                    single-line
                    hide-no-data
                    @change="obtenirListeRegionSelonPays()"
                  />
                </v-flex>

                <v-flex v-else md3>
                  <v-autocomplete
                    v-model.trim="paysSelectionne"
                    :items="listePays"
                    :readonly="produitReconduction"
                    item-value="paysRegion.code"
                    :item-text="item => item.paysRegion.fr"
                    class="text-caption pa-0 ma-0"
                    style="color: black;"
                    label=""
                    dense
                    single-line
                    hide-no-data
                    @change="obtenirListeRegionSelonPays()"
                  />
                </v-flex>

                <v-flex v-if="produitReconduction == false" md1 pt-4>
                  <v-btn
                    text
                    x-small
                    color="primary"
                    @click.stop="dialog = true"
                  >
                    Tous
                  </v-btn>
                </v-flex>
              </v-layout>

              <!-- ------------------ -->
              <!--- Dialog des pays ---->
              <!-- ------------------ -->
              <v-dialog v-model="dialog" width="450">
                <v-card>
                  <v-layout>
                    <v-flex md10 style="font-size: 12px">
                      <v-card-title class="text-h6"
                        >Liste des pays</v-card-title
                      >
                    </v-flex>
                    <v-flex md4 pt-3 pl-5 style="font-size: 12px">
                      <v-btn text color="primary" dark @click="close"
                        >Fermer</v-btn
                      >
                    </v-flex>
                  </v-layout>

                  <v-layout>
                    <v-row>
                      <v-flex
                        v-for="(item, index) in listePaysEtLettreFr"
                        :key="item.id"
                        pl-8
                        md1
                        :item="item"
                        :index="index"
                      >
                        <a :href="`#${item.lettre}`">
                          {{ item.lettre }}
                        </a>
                      </v-flex>
                    </v-row>
                  </v-layout>
                  <v-layout>
                    <div id="listePaysEtLettre">
                      <v-flex
                        v-for="(item, index) in listePaysEtLettreFr"
                        :key="item.id"
                        pl-5
                        :item="item"
                        :index="index"
                      >
                        <div :id="item.lettre"><br /></div>
                        <hr />
                        <v-flex
                          v-for="(item2, index2) in item.paysRegions"
                          :key="item2.code"
                          :item="item2"
                          :index="index2"
                        >
                          <a @click="initPays(item2)">
                            {{ item2.fr }}
                          </a>
                        </v-flex>
                      </v-flex>
                    </div>
                  </v-layout>
                  <v-btn text color="primary" dark @click="close">Fermer</v-btn>
                </v-card>
              </v-dialog>

              <v-layout>
                <v-flex md3 pt-1> Région </v-flex>

                <v-flex md3>
                  <v-select
                    v-model="regionSelectionne"
                    :disabled="produitReconduction || listeRegion.length == 0"
                    :items="listeRegion"
                    label="Sélectionnez"
                    item-value="1"
                    item-text="0"
                    class="text-caption pa-0"
                    style="color: black;"
                    dense
                    height="40"
                    single-line
                    hide-no-data
                    @change="obtenirListeSousRegionSelonRegion()"
                  >
                    <template v-slot:selection="data">
                      {{ data.item.paysRegion.fr }}
                    </template>
                    <template v-slot:item="data">
                      {{ data.item.paysRegion.fr }}
                    </template>
                  </v-select>
                </v-flex>
              </v-layout>

              <v-layout>
                <v-flex md3 pt-1> Sous-région </v-flex>

                <v-flex md3>
                  <v-select
                    v-model="sousRegionSelectionne"
                    :disabled="
                      produitReconduction || listeSousRegion.length == 0
                    "
                    :items="listeSousRegion"
                    label="Sélectionnez"
                    item-value="1"
                    item-text="0"
                    class="text-caption pa-0"
                    style="color: black;"
                    dense
                    height="40"
                    single-line
                    hide-no-data
                  >
                    <template v-slot:selection="data">
                      {{ data.item.paysRegion.fr }}
                    </template>
                    <template v-slot:item="data">
                      {{ data.item.paysRegion.fr }}
                    </template>
                  </v-select>
                </v-flex>
              </v-layout>

              <v-layout>
                <v-flex md3 pt-1> * Couleur </v-flex>

                <v-flex md3>
                  <v-select
                    v-model="couleur"
                    :items="listeCouleurSelonNature"
                    :readonly="produitReconduction"
                    label="Sélectionnez"
                    item-text="0"
                    item-value="1"
                    class="text-caption pa-0"
                    style="color: black;"
                    dense
                    height="40"
                    single-line
                    hide-no-data
                  >
                    <template v-slot:selection="data">
                      {{ data.item.couleur.fr }}
                    </template>
                    <template v-slot:item="data">
                      {{ data.item.couleur.fr }}
                    </template>
                  </v-select>
                </v-flex>
              </v-layout>

              <v-layout>
                <v-flex md3 pt-1 style="font-size: 12px"> Cépage1 </v-flex>
                <v-flex md5>
                  <v-text-field
                    v-model.trim="demande.demandeLigneData.cepage1"
                    :readonly="produitReconduction"
                    class="pa-0"
                    style="color: black;"
                    single-line
                    dense
                    outlined
                    maxlength="100"
                  />
                </v-flex>
              </v-layout>

              <v-layout>
                <v-flex md3 pt-1 style="font-size: 12px"> Cépage2 </v-flex>
                <v-flex md5>
                  <v-text-field
                    v-model.trim="demande.demandeLigneData.cepage2"
                    :readonly="produitReconduction"
                    class="pa-0"
                    style="color: black;"
                    single-line
                    dense
                    outlined
                    maxlength="100"
                  />
                </v-flex>
              </v-layout>

              <v-layout>
                <v-flex md3 pt-1 style="font-size: 12px"> * CUP </v-flex>
                <v-flex md2>
                  <v-text-field
                    v-model.trim="demande.demandeLigneData.cup"
                    :readonly="produitReconduction"
                    class="pa-0"
                    style="color: black;"
                    single-line
                    dense
                    outlined
                    maxlength="13"
                  />
                </v-flex>
              </v-layout>

              <v-layout>
                <v-flex md3 pt-1 style="font-size: 12px"> * SCC </v-flex>
                <v-flex md2>
                  <v-text-field
                    v-model.trim="demande.demandeLigneData.scc"
                    :readonly="produitReconduction"
                    class="pa-0"
                    style="color: black;"
                    single-line
                    dense
                    outlined
                    maxlength="14"
                  />
                </v-flex>
              </v-layout>

              <v-layout>
                <v-flex md3 pt-1 style="font-size: 12px"> * % d'alcool </v-flex>
                <v-flex md2>
                  <v-text-field
                    v-model.trim="pourcentageAlcool"
                    :readonly="produitReconduction"
                    class="pa-0"
                    style="color: black;"
                    single-line
                    dense
                    outlined
                  />
                </v-flex>
              </v-layout>

              <v-layout>
                <v-flex md3 pt-1 style="font-size: 12px">
                  Millésime / âge
                </v-flex>
                <v-flex md2>
                  <v-text-field
                    v-model.trim="demande.demandeLigneData.millesime"
                    :readonly="produitReconduction"
                    class="pa-0"
                    style="color: black;"
                    single-line
                    dense
                    outlined
                  />
                </v-flex>
              </v-layout>

              <v-layout>
                <v-flex md3 pt-1> * Format </v-flex>
                <v-flex md2 pt-1>
                  <v-text-field
                    v-model.trim="format"
                    :readonly="produitReconduction"
                    class="pa-0"
                    style="color: black;"
                    single-line
                    dense
                    outlined
                  />
                </v-flex>

                <v-flex md1 ml-5>
                  <v-select
                    v-model="demande.demandeLigneData.uniteMesure"
                    :readonly="produitReconduction"
                    :items="formatsBouteille"
                    item-text="1"
                    item-value="0"
                    class="text-caption pa-0"
                    dense
                    height="40"
                    single-line
                    hide-no-data
                  />
                </v-flex>
              </v-layout>

              <v-layout>
                <v-flex md3 pt-1> * Nbre bouteilles / caisse (UVC) </v-flex>
                <v-flex md2 pt-1>
                  <v-text-field
                    v-model.trim="uvc"
                    :readonly="produitReconduction"
                    class="pa-0"
                    style="color: black;"
                    single-line
                    dense
                    outlined
                  />
                </v-flex>
              </v-layout>

              <v-layout>
                <v-flex md3 pt-1> * Nbre caisses commandées </v-flex>
                <v-flex md2 pt-1>
                  <v-text-field
                    v-model.trim="nombreCaissesDemandees"
                    class="pa-0"
                    style="color: black;"
                    single-line
                    dense
                    outlined
                  />
                </v-flex>
              </v-layout>

              <v-layout>
                <v-flex md3 pt-3> * Type de contenant </v-flex>
                <v-flex md3>
                  <v-select
                    v-model="demande.demandeLigneData.typeContenant"
                    :readonly="produitReconduction"
                    required
                    :rules="[
                      v => !!v || 'Le type de contenant est obligatoire'
                    ]"
                    :items="typeContenants"
                    label="Sélectionnez"
                    item-text="1"
                    item-value="0"
                    class="text-caption pa-0"
                    style="color: black;"
                    dense
                    height="40"
                    single-line
                    hide-no-data
                  />
                </v-flex>
              </v-layout>

              <v-layout>
                <v-flex md3 pt-3> * Type de bouchon </v-flex>
                <v-flex md3>
                  <v-select
                    v-model="demande.demandeLigneData.typeBouchon"
                    :readonly="produitReconduction"
                    required
                    :rules="[v => !!v || 'Le type de bouchon est obligatoire']"
                    :items="typeBouchons"
                    label="Sélectionnez"
                    item-text="1"
                    item-value="0"
                    class="text-caption pa-0"
                    style="color: black;"
                    dense
                    height="40"
                    single-line
                    hide-no-data
                  />
                </v-flex>
              </v-layout>

              <v-layout>
                <v-flex md3 pt-1> * Devise du fournisseur </v-flex>

                <v-flex md2 pt-1>
                  <div class="pb-5">
                    {{
                      this.$store.getters.demande.infosFournisseur
                        .informationEnlevement.devise
                    }}
                  </div>
                </v-flex>
              </v-layout>

              <v-layout>
                <v-flex md3 pt-5> * Prix fournisseur (à la caisse) </v-flex>

                <v-flex md2 pt-1>
                  <v-text-field
                    v-model.trim="prixFournisseur"
                    class="pa-0"
                    single-line
                    dense
                    outlined
                  />
                </v-flex>
              </v-layout>

              <v-layout>
                <v-flex v-if="nomFichier == null" md3>
                  <v-row class="pt-4 pb-9">
                    <v-btn
                      small
                      text
                      color="primary"
                      class="white--text"
                      @click="clicAjouterFichier()"
                    >
                      Ajouter image de l'étiquette
                    </v-btn>
                  </v-row>
                </v-flex>
                <v-flex>
                  <input
                    id="fichier"
                    ref="fichier"
                    style="display: none"
                    type="file"
                    @change="uploadFichier()"
                  />

                  <div
                    v-if="nomFichier != null"
                    class="pb-5"
                    style="font-weight: bold; color: black"
                  >
                    Fichier ajouté à la demande : {{ nomFichier }}

                    <v-icon
                      v-if="produitReconduction == false"
                      medium
                      ml-3
                      mb-5
                      color="black"
                      @click="supprimerFichier()"
                    >
                      mdi-delete
                    </v-icon>
                  </div>

                  <div
                    v-else
                    class="md10 mt-5 ml-10"
                    style="font-weight: bold; color: black"
                  >
                    <div v-if="fichier != null && fichier.name != null">
                      {{ fichier.name }}

                      <v-icon
                        v-if="fichier != null && fichier.name != null"
                        medium
                        class="ml-3"
                        color="black"
                        @click="supprimerFichier()"
                      >
                        mdi-delete
                      </v-icon>
                    </div>
                  </div>
                </v-flex>
              </v-layout>

              <v-layout>
                <v-flex md3>
                  <v-btn
                    medium
                    color="primary"
                    style="text-transform: none;"
                    class="white--text"
                    :disabled="sending"
                    @click="soumettreAppelCalculette()"
                  >
                    Calculer le prix de vente estimé
                  </v-btn>
                </v-flex>
              </v-layout>

              <div class="pb-5 pt-5">
                Il est à noter que le prix calculé est approximatif et qu'il
                vous sera confirmé après l'acceptation du fournisseur
              </div>

              <v-flex
                v-if="resultatCalculette.prixDetailRevise != null"
                md8
                ml-5
                mt-5
                mb-5
              >
                <div class="font-weight-bold">
                  Prix de vente estimé :
                  {{ $fmtDecimal(resultatCalculette.prixDetailRevise) }} $
                </div>
                <div class="font-weight-bold">
                  Taux de la devise :
                  {{ this.$store.getters.demande.tauxDevise.montantConversion }}
                </div>
                <div>
                  Calculé le {{ $fmtTsEnDateEcrite() }} selon les derniers taux
                  publiés.
                </div>
              </v-flex>

              <v-spacer />

              <div class="pt-10">
                <v-btn
                  medium
                  color="primary"
                  style="text-transform: none;"
                  @click="creerMajDemande()"
                >
                  Sauvegarder le produit
                </v-btn>
              </div>
            </v-card>
          </v-stepper-content>

          <!-- --------------------  ->
          <!    STEP RECAPITULATIF  -->
          <!-- -------------------- -->

          <v-stepper-content step="3">
            <div class="pb-5 font-weight-bold">
              Dépôt exigé :
              {{ this.$store.getters.currentUser.infosClientJDE.coteABCAgent }}
              % du prix fournisseur
            </div>
            <!-- ------------------  ->
            <!    TYpe de paiement  -->
            <!-- ------------------ -->
            <v-layout
              v-if="
                this.$store.getters.currentUser.clientData
                  .indCapaciteFinanciere == true
              "
              class="pb-3"
            >
              Capacité financière disponible:
              {{ $fmtDecimal(capaciteFinanciere.montantCapacite) }} $
            </v-layout>

            <v-card>
              <v-layout class="pt-6">
                <v-flex md3> Numéro de la demande </v-flex>
                <v-flex md3>
                  {{ demandeData.noDemande }}
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex md3><span> Contact pour cette demande </span></v-flex>
                <v-flex md3>
                  {{
                    this.$store.getters.infosSupplementaire.nomContactDemande
                  }}
                </v-flex>
              </v-layout>

              <v-layout>
                <v-flex md3> <span>Nature de la demande </span></v-flex>
                <v-flex md3>
                  {{ this.$store.getters.infosSupplementaire.commentaire }}
                </v-flex>
              </v-layout>

              <v-layout>
                <v-flex md3> Terme d'achat </v-flex>
                <v-flex v-if="$store.getters.demande.termeAchat == 'FCA'" md3>
                  FCA - Transport assuré par la SAQ
                </v-flex>
                <v-flex v-if="$store.getters.demande.termeAchat == 'DDU'" md3>
                  DDU - Transport assuré par avion par le fournisseur
                </v-flex>
              </v-layout>
            </v-card>

            <v-card class="pa-3 pt-10">
              <v-layout>
                <v-flex>
                  <v-layout ml-4>
                    <!-- ------------------  ->
                    <!   Colonne de gauche  -->
                    <!-- ------------------ -->
                    <v-flex xs8>
                      <v-flex
                        class="font-weight-bold"
                        style="text-decoration: underline"
                        >COORDONNÉES DU CLIENT</v-flex
                      >
                      <v-layout>
                        <v-flex pt-5 md6> No de client SAQ : </v-flex>
                        <v-flex pt-5>
                          {{
                            this.$store.getters.currentUser.infosClientJDE
                              .noClientJDE
                          }}
                        </v-flex>
                      </v-layout>

                      <v-flex pt-5>
                        {{ this.$store.getters.currentUser.infosClientJDE.nom }}
                      </v-flex>
                      <v-flex>
                        {{
                          this.$store.getters.currentUser.infosClientJDE.adresse
                        }}
                      </v-flex>
                      <v-flex>
                        {{
                          this.$store.getters.currentUser.infosClientJDE.ville
                        }},
                        {{
                          this.$store.getters.currentUser.infosClientJDE
                            .codePostal
                        }}
                      </v-flex>

                      <v-flex pt-5>
                        {{
                          this.$store.getters.currentUser.infosClientJDE
                            .noTelephoneBureau1
                        }}
                      </v-flex>

                      <v-flex>
                        {{
                          this.$store.getters.currentUser.infosClientJDE
                            .adresseCourriel
                        }}
                      </v-flex>

                      <v-flex>
                        {{
                          this.$store.getters.currentUser.infosClientJDE
                            .nomResponsable
                        }}
                      </v-flex>
                    </v-flex>

                    <!-- ------------------ -->
                    <!-- Colonne du centre  -->
                    <!-- ------------------ -->
                    <v-flex xs8 pl-9>
                      <v-flex
                        class="font-weight-bold"
                        style="text-decoration: underline"
                        >ADRESSE DU LIEU D'ENLÈVEMENT</v-flex
                      >

                      <v-flex pt-5>
                        {{ infosFournisseur.noClientJDE }}
                      </v-flex>

                      <v-flex>
                        {{ infosFournisseur.informationEnlevement.nom }}
                      </v-flex>

                      <v-flex>
                        {{
                          infosFournisseur.informationEnlevement.adresseLigne1
                        }}
                      </v-flex>

                      <v-flex>
                        {{
                          infosFournisseur.informationEnlevement.villeRegion
                        }},
                        {{
                          infosFournisseur.informationEnlevement.provinceEtat
                        }}, {{ infosFournisseur.informationEnlevement.pays }}
                      </v-flex>

                      <v-flex>
                        {{ infosFournisseur.informationEnlevement.codePostal }}
                      </v-flex>

                      <v-flex>
                        {{ infosFournisseur.informationEnlevement.tel1 }}
                      </v-flex>

                      <v-flex>
                        {{ infosFournisseur.informationEnlevement.tel2 }}
                      </v-flex>

                      <v-flex>
                        {{ infosFournisseur.informationEnlevement.fax }}
                      </v-flex>

                      <v-flex>
                        {{ infosFournisseur.informationEnlevement.courriel }}
                      </v-flex>
                    </v-flex>

                    <!-- ------------------ -->
                    <!-- Colonne de droite  -->
                    <!-- ------------------ -->
                    <v-flex xs8 pl-9>
                      <v-flex
                        class="font-weight-bold"
                        style="text-decoration: underline"
                        >ADRESSE ADMINISTRATIVE</v-flex
                      >

                      <v-flex pt-5>
                        {{
                          infosFournisseur.informationsAdminstratives
                            .noFournisseur
                        }}
                      </v-flex>

                      <v-flex>
                        {{ infosFournisseur.informationsAdminstratives.nom }}
                      </v-flex>

                      <v-flex>
                        {{
                          infosFournisseur.informationsAdminstratives
                            .adresseLigne1
                        }}
                      </v-flex>

                      <v-flex>
                        {{
                          infosFournisseur.informationsAdminstratives
                            .villeRegion
                        }},
                        {{
                          infosFournisseur.informationsAdminstratives
                            .provinceEtat
                        }},
                        {{ infosFournisseur.informationsAdminstratives.pays }}
                      </v-flex>

                      <v-flex>
                        {{
                          infosFournisseur.informationsAdminstratives.codePostal
                        }}
                      </v-flex>

                      <v-flex>
                        {{ infosFournisseur.informationsAdminstratives.tel1 }}
                      </v-flex>

                      <v-flex>
                        {{ infosFournisseur.informationsAdminstratives.tel2 }}
                      </v-flex>

                      <v-flex>
                        {{ infosFournisseur.informationsAdminstratives.fax }}
                      </v-flex>

                      <v-flex>
                        {{
                          infosFournisseur.informationsAdminstratives.courriel
                        }}
                      </v-flex>
                    </v-flex>
                  </v-layout>

                  <!-- ------------------------------ -->
                  <!--    Produits recapitulatif      -->
                  <!-- ------------------------------ -->

                  <v-data-table
                    v-if="afficherAjoutProduit == false"
                    :headers="headersConfirmation"
                    :items="demandeData.listeDemandeLigneData"
                    hide-default-footer
                    class="pt-8"
                    dense
                    disable-pagination
                  >
                    <template v-slot:item.description="{ item }">
                      <span style="font-size: 12px">
                        {{ item.description }}
                      </span>
                    </template>

                    <template
                      v-slot:item.infoProduitMatrice.paysOrigine.fr="{ item }"
                    >
                      <span style="font-size: 12px">
                        {{ item.infoProduitMatrice.paysOrigine.fr }}
                      </span>
                    </template>

                    <template v-slot:item.uvc="{ item }">
                      <span style="font-size: 12px"
                        >{{ item.uvc }} x {{ item.formatBtl }}
                        {{ formatBouteille.get(item.uniteMesure) }}</span
                      >
                    </template>

                    <template v-slot:item.prixFournisseur="{ item }">
                      <span style="font-size: 12px">
                        {{ $fmtDecimal(item.prixFournisseur) }}
                      </span>
                    </template>

                    <template v-slot:item.prixDetail="{ item }">
                      <span style="font-size: 12px">
                        {{ $fmtDecimal(item.prixDetail) }} $
                      </span>
                    </template>

                    <template v-slot:item.montantCalcule="{ item }">
                      <span style="font-size: 12px">
                        {{ $fmtDecimal(item.montantCalcule) }} $
                        {{ devise.get(item.devise) }}
                      </span>
                    </template>

                    <template v-slot:item.montantCalculeCAD="{ item }">
                      <span style="font-size: 12px">
                        {{ $fmtDecimal(item.montantCalculeCAD) }} $
                      </span>
                    </template>

                    <template v-slot:item.montantDepotAVerser="{ item }">
                      <span style="font-size: 12px">
                        {{ $fmtDecimal(item.montantDepotAVerser) }} $
                      </span>
                    </template>

                    <template v-slot:item.actionAfficherInfo="props">
                      <v-icon
                        medium
                        class="mr-2"
                        color="accent"
                        @click="afficherInfosComplementaire(props.item)"
                      >
                        list_alt
                      </v-icon>
                    </template>
                  </v-data-table>

                  <v-dialog
                    v-model="dialogInfoProduit"
                    :retain-focus="false"
                    width="500"
                  >
                    <v-card>
                      <v-card-title class="grey lighten-3">
                        Informations produits
                      </v-card-title>

                      <v-divider />

                      <div class="pl-8 pt-5">
                        <span class="pr-5" style="font-weight: bold"
                          >Nom du producteur:
                        </span>
                        <span class="pl-7">{{
                          infosComplementaire.nomProducteur
                        }}</span>
                      </div>

                      <div class="pl-8 pt-1">
                        <span class="pr-5" style="font-weight: bold"
                          >Marque commerciale:</span
                        >
                        <span class="pl-5">{{
                          infosComplementaire.marqueCommerciale
                        }}</span>
                      </div>

                      <div class="pl-8 pt-1">
                        <span class="pr-7" style="font-weight: bold"
                          >Nom de la cuvée:</span
                        >
                        <span class="pl-10">{{
                          infosComplementaire.nomCuvee
                        }}</span>
                      </div>

                      <div
                        v-if="
                          infosComplementaire.infoProduitMatrice.nature != null
                        "
                        class="pl-8 pt-1"
                      >
                        <span class="pr-15" style="font-weight: bold"
                          >Nature:</span
                        >
                        <span class="pl-14">
                          {{
                            infosComplementaire.infoProduitMatrice.nature.fr
                          }}</span
                        >
                      </div>

                      <div
                        v-if="
                          infosComplementaire.infoProduitMatrice.famille != null
                        "
                        class="pl-8 pt-1"
                      >
                        <span class="pr-14" style="font-weight: bold"
                          >Famille:</span
                        >
                        <span class="pl-15">{{
                          infosComplementaire.infoProduitMatrice.famille.fr
                        }}</span>
                      </div>

                      <div
                        v-if="
                          infosComplementaire.infoProduitMatrice.type != null
                        "
                        class="pl-8 pt-1"
                      >
                        <span class="pr-16" style="font-weight: bold"
                          >Type:</span
                        >
                        <span class="pl-16">{{
                          infosComplementaire.infoProduitMatrice.type.fr
                        }}</span>
                      </div>

                      <div
                        v-if="
                          infosComplementaire.infoProduitMatrice.paysOrigine !=
                            null
                        "
                        class="pl-8 pt-1"
                      >
                        <span class="pr-10" style="font-weight: bold"
                          >Pays d'origine:</span
                        >
                        <span class="pl-10">{{
                          infosComplementaire.infoProduitMatrice.paysOrigine.fr
                        }}</span>
                      </div>

                      <div
                        v-if="
                          infosComplementaire.infoProduitMatrice
                            .regionOrigine != null
                        "
                        class="pl-8 pt-1"
                      >
                        <span class="pr-14" style="font-weight: bold"
                          >Région:</span
                        >
                        <span class="pl-15">{{
                          infosComplementaire.infoProduitMatrice.regionOrigine
                            .fr
                        }}</span>
                      </div>

                      <div
                        v-if="
                          infosComplementaire.infoProduitMatrice
                            .sousRegionOrigine != null
                        "
                        class="pl-8 pt-1"
                      >
                        <span class="pr-12" style="font-weight: bold"
                          >Sous-région:</span
                        >
                        <span class="pl-10">{{
                          infosComplementaire.infoProduitMatrice
                            .sousRegionOrigine.fr
                        }}</span>
                      </div>

                      <div
                        v-if="
                          infosComplementaire.infoProduitMatrice.couleur != null
                        "
                        class="pl-8 pt-1"
                      >
                        <span class="pr-13" style="font-weight: bold"
                          >Couleur:</span
                        >
                        <span class="pl-15">{{
                          infosComplementaire.infoProduitMatrice.couleur.fr
                        }}</span>
                      </div>

                      <div class="pl-8 pt-1">
                        <span class="pr-12" style="font-weight: bold"
                          >Cépage1:</span
                        >
                        <span class="pl-15">{{
                          infosComplementaire.cepage1
                        }}</span>
                      </div>

                      <div class="pl-8 pt-1">
                        <span class="pr-12" style="font-weight: bold"
                          >Cépage2:</span
                        >
                        <span class="pl-15">{{
                          infosComplementaire.cepage2
                        }}</span>
                      </div>

                      <div class="pl-8 pt-1">
                        <span class="pr-16" style="font-weight: bold"
                          >CUP:</span
                        >
                        <span class="pl-16">{{ infosComplementaire.cup }}</span>
                      </div>

                      <div class="pl-8 pt-1">
                        <span class="mr-16" style="font-weight: bold"
                          >SCC:</span
                        >
                        <span class="ml-16">{{ infosComplementaire.scc }}</span>
                      </div>

                      <div class="pl-8 pt-1">
                        <span class="pr-5" style="font-weight: bold"
                          >Pourcentage d'alcool:</span
                        >
                        <span class="pl-5"
                          >{{ infosComplementaire.pourcentageAlcool }} %</span
                        >
                      </div>

                      <div class="pl-8 pt-1">
                        <span class="pr-7" style="font-weight: bold"
                          >Millésime / âge:</span
                        >
                        <span class="pl-10">{{
                          infosComplementaire.millesime
                        }}</span>
                      </div>

                      <div class="pl-8 pt-1">
                        <span class="pr-10" style="font-weight: bold"
                          >Type de contenant:</span
                        >
                        <span class="pl-2">
                          {{
                            listeTypeContenants.get(
                              infosComplementaire.typeContenant
                            )
                          }}</span
                        >
                      </div>

                      <div class="pl-8 pt-1 pb-5">
                        <span class="pr-5" style="font-weight: bold"
                          >Type de bouchon:</span
                        >
                        <span class="pl-10">{{
                          listeTypeBouchons.get(infosComplementaire.typeBouchon)
                        }}</span>
                      </div>

                      <v-card-actions>
                        <v-spacer />
                        <v-btn
                          color="primary"
                          text
                          @click="dialogInfoProduit = false"
                        >
                          Fermer
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>

                  <div
                    v-if="demandeData.montantTotalCAD != null"
                    class="pl-5 pt-2"
                    style="font-weight: bold"
                  >
                    *UVC : nombre de bouteilles dans une caisse
                  </div>
                  <div
                    v-if="
                      (afficherAjoutProduit == false &&
                        this.$store.getters.currentUser.clientData.typeClient ==
                          'TITULAIRE_POUR_REVENTE') ||
                        this.$store.getters.currentUser.clientData.typeClient ==
                          'BOUTIQUE_HORS_TAXE'
                    "
                    class="pl-5"
                    style="font-weight: bold"
                  >
                    **Les taxes sont exclues du prix de vente estimé par
                    bouteille.
                  </div>

                  <!-- ------ -->
                  <!-- Totaux -->
                  <!-- ------ -->
                  <table class="pl-10 pt-5 pb-10" style="font-weight: bold">
                    <tr>
                      <td style="width: 200px"></td>
                      <td style="width: 500px"></td>
                      <td style="width: 100px; text-align: right">Total :</td>
                      <td style="width: 100px; text-align: right">
                        {{ $fmtDecimal(demandeData.montantTotalCAD) }} $
                      </td>
                      <td style="width: 350px"></td>
                      <td style="width: 350px">
                        {{ $fmtDecimal(demandeData.montantTotalDepot) }} $
                      </td>
                    </tr>

                    <tr>
                      <td style="width: 200px"></td>
                      <td style="width: 300px"></td>
                      <td style="width: 200px; text-align: right">
                        TOTAL À PAYER :
                      </td>
                      <td style="width: 100px; text-align: right">
                        {{ $fmtDecimal(demandeData.montantTotalCAD) }} $
                      </td>
                      <td style="width: 350px"></td>
                      <td style="width: 250px">
                        {{ $fmtDecimal(demandeData.montantTotalDepot) }} $
                      </td>
                    </tr>
                  </table>

                  <!-- ------------------------------ -->
                  <!-- Payer avec capacité financière -->
                  <!-- ------------------------------ -->
                  <div
                    v-if="
                      $store.getters.currentUser.clientData
                        .indCapaciteFinanciere
                    "
                  >
                    <v-layout class="pb-5 pl-5 pt-8 font-weight-bold">
                      <v-flex>
                        <div>
                          Capacité financière disponible:
                          {{ $fmtDecimal(capaciteFinanciere.montantCapacite) }}
                          $
                        </div>
                        <div>
                          Le montant de
                          {{ $fmtDecimal(demandeData.montantTotalDepot) }} $
                          sera déduit de votre capacité financière
                        </div>
                      </v-flex>
                    </v-layout>

                    <v-layout>
                      <v-checkbox v-model="checkbox1" pl-5>
                        <template v-slot:label> </template>
                      </v-checkbox>
                      <span class="pl-3 pt-6">
                        <router-link
                          :to="{ name: 'modalitesRenseignement' }"
                          target="_blank"
                        >
                          J'ai lu et accepte les conditions de la Politique de
                          confidentialité
                        </router-link></span
                      >
                    </v-layout>
                    <v-layout>
                      <v-checkbox v-model="checkbox2" pl-5>
                        <template v-slot:label> </template>
                      </v-checkbox>

                      <span
                        v-if="
                          this.$store.getters.currentUser.clientData
                            .typeClient == 'TITULAIRE_POUR_REVENTE' ||
                            this.$store.getters.currentUser.clientData
                              .typeClient == 'BOUTIQUE_HORS_TAXE'
                        "
                        class="pl-3 pt-6"
                      >
                        <router-link
                          :to="{ name: 'politiqueTitulairePermis' }"
                          target="_blank"
                        >
                          J’ai lu et accepte les conditions de la Politique
                          d’importations privées.
                        </router-link></span
                      >

                      <span v-else class="pl-3 pt-6">
                        <router-link
                          :to="{ name: 'politiqueParticulier' }"
                          target="_blank"
                        >
                          J’ai lu et accepte les conditions de la Politique
                          d’importations privées.
                        </router-link></span
                      >
                    </v-layout>

                    <v-layout class="pb-2 font-weight-bold">
                      <v-row class="justify-left pt-8">
                        <v-btn
                          medium
                          color="primary"
                          style="text-transform: none;"
                          class="ml-10"
                          :disabled="sending"
                          @click="soumettreDemande()"
                        >
                          Transmettre la demande
                        </v-btn>

                        <v-btn
                          v-if="demandeData.montantTotal != null"
                          medium
                          color="primary"
                          style="text-transform: none;"
                          class="ml-13"
                          @click="soumettreEnBrouillon()"
                        >
                          Enregistrer en brouillon
                        </v-btn>

                        <v-btn
                          v-if="isPeutPayerAvecCapacite() == false"
                          medium
                          color="primary"
                          style="text-transform: none;"
                          class="ml-10"
                          @click="versPageCapacite()"
                        >
                          Augmenter ma capacité financière
                        </v-btn>
                      </v-row>
                    </v-layout>
                  </div>

                  <div class="pt-8"></div>
                </v-flex>
              </v-layout>
            </v-card>
          </v-stepper-content>

          <!-- ------------------------------ -->
          <!-- Paiement par carte de credit -->
          <!-- ------------------------------ -->
          <v-stepper-content step="4">
            <v-layout pl-2>
              <v-checkbox v-model="checkbox1" />
              <span class="pt-6">
                <router-link
                  :to="{ name: 'modalitesRenseignement' }"
                  target="_blank"
                >
                  J'ai lu et accepte les conditions de la Politique de
                  confidentialité
                </router-link></span
              >
            </v-layout>
            <v-layout mb-5 pl-2>
              <v-checkbox v-model="checkbox2" />

              <div
                v-if="
                  this.$store.getters.currentUser.clientData.typeClient ==
                    'TITULAIRE_POUR_REVENTE' ||
                    this.$store.getters.currentUser.clientData.typeClient ==
                      'BOUTIQUE_HORS_TAXE'
                "
                class="pt-6"
              >
                <router-link
                  :to="{ name: 'politiqueTitulairePermis' }"
                  target="_blank"
                >
                  J’ai lu et accepte les conditions de la Politique
                  d’importations privées.
                </router-link>
              </div>

              <div v-else class="pt-6">
                <router-link
                  :to="{ name: 'politiqueParticulier' }"
                  target="_blank"
                >
                  J’ai lu et accepte les conditions de la Politique
                  d’importations privées.
                </router-link>
              </div>
            </v-layout>

            <div
              v-if="resultatPaiement == 'V100'"
              class="pb-1 pb-8"
              style="font-weight: bold;color: red; font-size: 16px;"
            >
              La transaction est refusée, veuillez recommencer
            </div>

            <v-layout
              v-if="
                demandeData.statutDemande != 'EN_ATTENTE_MODIFICATION_CLIENT'
              "
            >
              <v-row align="center" justify="center">
                <div id="outerDiv" style="height:750px; width:600px;">
                  <div id="monerisCheckout"></div>
                </div>
              </v-row>
            </v-layout>

            <v-row align="center" justify="center">
              <v-btn
                v-if="demandeData.montantTotal != null"
                medium
                color="primary"
                style="text-transform: none;"
                class="ml-13"
                @click="soumettreEnBrouillon()"
              >
                Enregistrer en brouillon
              </v-btn>

              <v-btn
                v-if="
                  demandeData.montantTotal != null &&
                    demandeData.statutDemande ==
                      'EN_ATTENTE_MODIFICATION_CLIENT'
                "
                medium
                color="primary"
                style="text-transform: none;"
                class="ml-13"
                @click="soumettreModicationsClients()"
              >
                Enregistrer les changements
              </v-btn>
            </v-row>
          </v-stepper-content>
        </v-stepper-items>

        <v-stepper-header>
          <v-stepper-step step="1" editable>Fournisseur</v-stepper-step>
          <v-stepper-step step="2" editable>Produits</v-stepper-step>
          <v-stepper-step step="3" editable>Récapitulatif</v-stepper-step>
          <v-stepper-step
            v-if="$store.getters.currentUser.clientData.indComptant == true"
            step="4"
            editable
            @click="initCarteCredit"
            >Paiement</v-stepper-step
          >

          <v-divider />
        </v-stepper-header>
      </v-stepper>
    </v-row>
  </v-container>
</template>

<script>
import stepFournisseur from '@/components/demande/StepFournisseur.vue'
import i18n from '@/plugins/i18n'
import { mask } from '@titou10/v-mask'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import moment from 'moment'
import {
  formatsBouteille,
  devise,
  typePrix,
  typeContenant,
  typeBouchon
} from '@/plugins/enums'
export default {
  name: 'DemandeIP',
  components: {
    stepFournisseur
  },
  directives: { mask },
  mixins: [validationMixin],
  data() {
    return {
      demande: {
        clientData: {},
        demandeLigneData: {},
        demandeFournisseurData: {}
      },
      demandeData: {},
      sending: false,
      description: null,
      modeAjout: false,
      nomFichier: null,
      pourcentageAlcool: null,
      paysSelectionne: { paysRegion: {} },
      regionSelectionne: { paysRegion: {} },
      sousRegionSelectionne: { paysRegion: {} },
      natureSelectionne: { natureFamilleType: {} },
      familleSelectionne: { natureFamilleType: {} },
      typeSelectionne: { natureFamilleType: {} },
      couleur: { couleur: {} },
      nomProducteur: null,
      marqueCommerciale: '',
      nomCuvee: '',
      format: null,
      uvc: null,
      nombreCaissesDemandees: null,
      prixFournisseur: null,
      prixDetail: null,
      produitReconduction: false,
      categorieDepot: 0,
      capaciteFinanciere: {},
      garantieBancaire: {},
      montant: null,
      listePaysFrequents: [],
      listePays: [],
      listePaysEtLettreFr: [],
      listeNature: [],
      listeRegion: [],
      listeCouleur: [],
      listeCouleurSelonNature: [],
      listeSousRegion: [],
      listeType: [],
      resultatCalculette: {},
      nature: null,
      famille: null,
      listeFournisseur: [],
      loading: false,
      items: [],
      recherche: null,
      produitSelect: null,
      search: null,
      select: null,
      produitRecherche: [],
      listeFamille: [],
      soumisCalculette: false,
      afficherAjoutProduit: false,
      dialog: false,
      dialogInfoProduit: false,
      fichier: [],
      checkbox1: 0,
      checkbox2: 0,
      resultatPaiement: {},
      ticket: {},
      env: null,
      infosComplementaire: { infoProduitMatrice: {} },

      headers: [
        {
          text: 'Description',
          value: 'description',
          align: 'left',
          width: '100px'
        },
        {
          text: "Pays d'origine",
          value: 'infoProduitMatrice.paysOrigine.fr',
          align: 'left',
          width: '100px'
        },
        {
          text: 'UVC* x format',
          value: 'uvc',
          width: '150px'
        },
        {
          text: 'Nbre caisses',
          value: 'nombreCaissesDemandees',
          width: '100px'
        },
        {
          text: 'Prix caisse',
          value: 'prixFournisseur',
          width: '100px'
        },
        {
          text: 'Montant total',
          value: 'montantCalcule',
          width: '100px'
        },
        {
          text: 'Montant total (CAD)',
          value: 'montantCalculeCAD',
          width: '100px'
        },
        {
          text: 'Prix estimé/btle (CAD)**',
          value: 'prixDetail',
          width: '100px'
        },
        {
          text: 'Dépôt (CAD)',
          value: 'montantDepotAVerser',
          width: '100px'
        },
        {
          text: 'Afficher les informations supplémentaires',
          value: 'actionAfficherInfo',
          align: 'center',
          width: '100px'
        },
        { text: 'Actions', value: 'action', width: '100px' }
      ],
      headersConfirmation: [
        {
          text: 'Description',
          value: 'description',
          align: 'left',
          width: '100px'
        },
        {
          text: "Pays d'origine",
          value: 'infoProduitMatrice.paysOrigine.fr',
          align: 'left',
          width: '100px'
        },
        {
          text: 'UVC* x format',
          value: 'uvc',
          width: '150px'
        },
        {
          text: 'Nbre caisses',
          value: 'nombreCaissesDemandees',
          width: '100px'
        },
        {
          text: 'Prix caisse',
          value: 'prixFournisseur',
          width: '100px'
        },
        {
          text: 'Montant total',
          value: 'montantCalcule',
          width: '100px'
        },
        {
          text: 'Montant total (CAD)',
          value: 'montantCalculeCAD',
          width: '100px'
        },
        {
          text: 'Prix estimé/btle (CAD)**',
          value: 'prixDetail',
          width: '100px'
        },
        {
          text: 'Dépôt (CAD)',
          value: 'montantDepotAVerser',
          width: '100px'
        },
        {
          text: 'Afficher les informations supplémentaires',
          value: 'actionAfficherInfo',
          align: 'center',
          width: '100px'
        }
      ]
    }
  },

  computed: {
    infosFournisseur: function() {
      return this.$store.getters.demande.infosFournisseur
    },
    formatsBouteille: function() {
      return Array.from(formatsBouteille)
    },
    formatBouteille: function() {
      return formatsBouteille
    },
    devise: function() {
      return devise
    },
    typePrix: function() {
      return Array.from(typePrix)
    },
    typeContenants: function() {
      return Array.from(typeContenant)
    },
    listeTypeContenants: function() {
      return typeContenant
    },
    typeBouchons: function() {
      return Array.from(typeBouchon)
    },
    listeTypeBouchons: function() {
      return typeBouchon
    },

    itemsProduit() {
      return this.produitRecherche.map(p => {
        const infoProduit =
          p.noProduitJDE +
          ' ' +
          p.description +
          '    -   ' +
          p.noFournisseur +
          ' ' +
          p.nomFournisseur
        return Object.assign({}, p, { infoProduit })
      })
    }
  },

  watch: {
    recherche(val) {
      if (val == null || val == '') {
        this.produitRecherche = []
      } else {
        this.produitRecherche = this.$store.getters.demande.listeProduits
      }
    }
  },

  beforeMount() {
    this.afficherAjoutProduit = false

    this.obtenirEnv()

    this.obtenirListeCouleur()

    this.$store.getters.demande.infosFournisseur = {
      informationEnlevement: {},
      informationsAdminstratives: {}
    }

    if (this.$route.params.noDemande != null) {
      this.obtenirDemande()
    }

    if (
      this.$store.getters.currentUser.clientData.indCapaciteFinanciere == true
    ) {
      this.obtenirCapaciteFinanciere()
    }
  },

  methods: {

  obtenirEnv(){
    axios
      .get(
        `/gestioncartecredit/obtenirenvironnement`
      )
      .then(response => {
        let resp = response.data
        if (resp.codeRetour == 'OK') {
          this.env = resp.resultat
        } else {
          console.log(`erreur resp.codeRetour=${resp.codeRetour}`)
          let msg = this.$fmtApiErr(resp)
          console.log(msg)
          this.$store.dispatch('afficherError', msg)
        }
      })
      .catch(error => {
        console.log('error=' + error)
        let msg = this.$fmtAxiosErr(error)
        this.$store.dispatch('afficherError', msg)
      })
  },

    afficherInfosComplementaire(id) {
      this.infosComplementaire = id
      this.dialogInfoProduit = true
    },

    text: item => 'titi' + ' — ' + 'toto',

    selectionnerProduit() {
      console.log('selectionnerProduit')

      this.nomProducteur = this.produitSelect.nomProducteur
      this.marqueCommerciale = this.produitSelect.marqueCommerciale
      this.nomCuvee = this.produitSelect.nomCuvee

      this.description = this.produitSelect.description
      this.regionSelectionne = this.produitSelect.regionSelectionne
      this.sousRegionSelectionne = this.produitSelect.sousRegionSelectionne

      this.paysSelectionne = { paysRegion: {} }
      this.paysSelectionne.paysRegion = this.produitSelect.infoProduitMatrice.paysOrigine

      this.regionSelectionne = { paysRegion: {} }
      this.regionSelectionne.paysRegion = this.produitSelect.infoProduitMatrice.regionOrigine

      this.sousRegionSelectionne = { paysRegion: {} }
      this.sousRegionSelectionne.paysRegion = this.produitSelect.infoProduitMatrice.sousRegionOrigine

      this.natureSelectionne = { natureFamilleType: {} }
      this.natureSelectionne.natureFamilleType = this.produitSelect.infoProduitMatrice.nature

      this.familleSelectionne = { natureFamilleType: {} }
      this.familleSelectionne.natureFamilleType = this.produitSelect.infoProduitMatrice.famille

      if (this.produitSelect.infoProduitMatrice.type != null) {
        this.typeSelectionne = { natureFamilleType: {} }
        this.typeSelectionne.natureFamilleType = this.produitSelect.infoProduitMatrice.type
        this.obtenirTypeSelonFamille()
      }

      this.couleur = { couleur: {} }
      this.couleur.couleur = this.produitSelect.infoProduitMatrice.couleur

      this.pourcentageAlcool = this.produitSelect.pourcentageAlcool
      this.demande.demandeLigneData.millesime = this.produitSelect.millesime
      this.demande.demandeLigneData.cup = this.produitSelect.cup
      this.demande.demandeLigneData.scc = this.produitSelect.scc
      this.demande.demandeLigneData.cepage1 = this.produitSelect.cepage1
      this.demande.demandeLigneData.cepage2 = this.produitSelect.cepage2

      this.format = this.produitSelect.format
      this.demande.demandeLigneData.uniteMesure = this.produitSelect.uniteMesure
      this.demande.demandeLigneData.contenant = this.produitSelect.contenant
      this.uvc = this.produitSelect.uvc
      this.nombreCaissesDemandees = this.produitSelect.nombreCaissesDemandees
      this.demande.demandeLigneData.typeContenant = this.produitSelect.typeContenant
      this.demande.demandeLigneData.typeBouchon = this.produitSelect.typeBouchon
      this.nomFichier = this.produitSelect.nomFichier
      this.demande.demandeLigneData.noProduitJDE = this.produitSelect.noProduitJDE
      this.prixFournisseur = this.produitSelect.prixFournisseur

      this.produitReconduction = true

      this.initPays()
      this.obtenirListePays()
      this.obtenirListeRegionSelonPays()
      this.obtenirListeNature()
      this.obtenirListeFamilleSelonNature()

      if (
        this.sousRegionSelectionne != null &&
        this.sousRegionSelectionne.paysRegion != null
      ) {
        this.obtenirListeSousRegionSelonRegion()
      }

      // Pour remettre à blanc le select
      this.$nextTick(() => {
        this.produitSelect = null
      })
    },

    modifierProduit(item) {
      console.log('modifierProduit ' + item.id)

      this.modeAjout = false
      this.afficherAjoutProduit = true
      this.produitSelect = item
      this.prixFournisseur = item.prixFournisseur

      this.demande.noDemande = this.demandeData.noDemande
      this.demande.demandeLigneData.id = item.id
      this.demande.demandeLigneData.indNouvelleLigneProduit = false

      this.selectionnerProduit()

      this.resultatCalculette = {}

      //this.fichier = item.fichier
      this.nomFichier = this.fichier.name

      this.obtenirListePaysFrequent()
      this.obtenirListePays()
      this.obtenirListePaysLettreFr()

      this.paysSelectionne.paysRegion = item.infoProduitMatrice.paysOrigine
      this.regionSelectionne.paysRegion = item.infoProduitMatrice.regionOrigine
      this.sousRegionSelectionne.paysRegion =
        item.infoProduitMatrice.sousRegionOrigine

      this.natureSelectionne.natureFamilleType = item.infoProduitMatrice.nature
      this.familleSelectionne.natureFamilleType =
        item.infoProduitMatrice.famille

      this.couleur.couleur = item.infoProduitMatrice.couleur

      this.obtenirListeRegionSelonPays()

      if (
        this.sousRegionSelectionne != null &&
        this.sousRegionSelectionne.paysRegion != null
      ) {
        this.obtenirListeSousRegionSelonRegion()
      }

      this.produitReconduction = false
      if (item.noProduitJDE != undefined && this.listeProduits != null) {
        for (let i = 0; i < this.listeProduits.length; i++) {
          if (this.listeProduits[i].noProduitJDE == item.noProduitJDE) {
            console.log('produit de reconduction')
            this.produitReconduction = true
          }
        }
      }

      this.soumisCalculette = false
    },

    supprimerProduit(item) {
      console.log('supprimer')
      if (!confirm('Êtes vous sûr de vouloir supprimer ce produit ?')) {
        return
      }

      let index = this.demandeData.listeDemandeLigneData.indexOf(item)

      axios
        .delete(`/demande/${item.id}`)
        .then(response => {
          let resp = response.data
          let msg = null
          switch (resp.codeRetour) {
            case 'OK':
              //this.demandeData.listeDemandeLigneData.splice(index, 1)

              this.demandeData = resp.resultat

              break
            case 'W001':
              break
            default:
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              break
          }
        })
        .catch(error => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
    },

    submit() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.soumettreEnBrouillon()
      }
    },

    creerMajDemande() {
      console.log('creerMajDemande')

      if (this.soumisCalculette == false) {
        this.$store.dispatch(
          'afficherWarning',
          'Vous devez calculer le prix de vente estimé avant de sauvegarder le produit'
        )
        return
      }

      this.demande.demandeLigneData.nombreCaissesDemandees = this.nombreCaissesDemandees

      var montantCalculCAD =
        this.demande.demandeLigneData.prixFournisseur *
        this.$store.getters.demande.tauxDevise.montantConversion *
        this.demande.demandeLigneData.nombreCaissesDemandees

      console.log(
        'prix fournisseur :' +
          this.demande.demandeLigneData.prixFournisseur +
          ' devise : ' +
          this.$store.getters.demande.tauxDevise.montantConversion +
          ' nombre de caisse : ' +
          this.demande.demandeLigneData.nombreCaissesDemandees +
          ' montant total  ' +
          montantCalculCAD
      )

      if (
        montantCalculCAD < 150 &&
        this.demande.demandeLigneData.nombreCaissesDemandees < parseInt('5')
      ) {
        this.$store.dispatch(
          'afficherWarning',
          'Le montant minimum par produit est de 150 $ ou de 5 caisses'
        )
        return
      }

      const fichier = this.$refs.fichier.files[0]

      if (this.demandeData.statutDemande == null) {
        // on créer la demande
        this.creerDemande()
      } else {
        if (this.demandeData.noDemande != null) {
          if (this.demande.demandeLigneData.indNouvelleLigneProduit == true) {
            this.ajouterProduit()
          } else {
            this.modifierProduitDemande()
          }
        }
      }

      this.soumisCalculette = false
    },

    creerDemande() {
      console.log('creerDemande')

      this.demande.clientData.noClientJDE = this.$store.getters.currentUser.infosClientJDE.noClientJDE
      this.demande.demandeFournisseurData.noFournisseurEnlevement = this.infosFournisseur.noClientJDE
      this.demande.demandeFournisseurData.nomFournisseurEnlevement = this.infosFournisseur.informationEnlevement.nom
      this.demande.demandeFournisseurData.nomMaisonMereEnlevement = this.infosFournisseur.informationEnlevement.nomMaisonMere
      this.demande.demandeFournisseurData.deviseEnlevement = this.infosFournisseur.informationEnlevement.devise
      this.demande.demandeFournisseurData.nomContactFournisseurEnlevement = this.infosFournisseur.informationEnlevement.nomContact
      this.demande.demandeFournisseurData.adresse1Enlevement = this.infosFournisseur.informationEnlevement.adresseLigne1
      this.demande.demandeFournisseurData.adresse2Enlevement = this.infosFournisseur.informationEnlevement.adresseLigne2
      this.demande.demandeFournisseurData.adresse3Enlevement = this.infosFournisseur.informationEnlevement.adresseLigne3
      this.demande.demandeFournisseurData.villeRegionEnlevement = this.infosFournisseur.informationEnlevement.villeRegion
      this.demande.demandeFournisseurData.provinceEtatEnlevement = this.infosFournisseur.informationEnlevement.provinceEtat
      this.demande.demandeFournisseurData.paysEnlevement = this.infosFournisseur.informationEnlevement.pays
      this.demande.demandeFournisseurData.codePostalEnlevement = this.infosFournisseur.informationEnlevement.codePostal
      this.demande.demandeFournisseurData.noTelephone1Enlevement = this.infosFournisseur.informationEnlevement.tel1
      this.demande.demandeFournisseurData.courrielFournisseurEnlevement = this.infosFournisseur.informationEnlevement.courriel

      this.demande.demandeFournisseurData.noFournisseurAdminstrative = this.infosFournisseur.informationsAdminstratives.noFournisseur
      this.demande.demandeFournisseurData.nomFournisseurAdminstrative = this.infosFournisseur.informationsAdminstratives.nom
      this.demande.demandeFournisseurData.nomMaisonMereAdminstrative = this.infosFournisseur.informationsAdminstratives.nomMaisonMere
      this.demande.demandeFournisseurData.deviseAdminstrative = this.infosFournisseur.informationsAdminstratives.devise
      this.demande.demandeFournisseurData.nomContactFournisseurAdminstrative = this.infosFournisseur.informationsAdminstratives.nomContact
      this.demande.demandeFournisseurData.adresse1Adminstrative = this.infosFournisseur.informationsAdminstratives.adresseLigne1
      this.demande.demandeFournisseurData.adresse2Adminstrative = this.infosFournisseur.informationsAdminstratives.adresseLigne2
      this.demande.demandeFournisseurData.adresse3Adminstrative = this.infosFournisseur.informationsAdminstratives.adresseLigne3
      this.demande.demandeFournisseurData.villeRegionAdminstrative = this.infosFournisseur.informationsAdminstratives.villeRegion
      this.demande.demandeFournisseurData.provinceEtatAdminstrative = this.infosFournisseur.informationsAdminstratives.provinceEtat
      this.demande.demandeFournisseurData.paysAdminstrative = this.infosFournisseur.informationsAdminstratives.pays
      this.demande.demandeFournisseurData.codePostalAdminstrative = this.infosFournisseur.informationsAdminstratives.codePostal
      this.demande.demandeFournisseurData.noTelephone1Adminstrative = this.infosFournisseur.informationsAdminstratives.tel1
      this.demande.demandeFournisseurData.courrielFournisseurAdminstrative = this.infosFournisseur.informationsAdminstratives.courriel

      this.demande.demandeLigneData.prixFournisseur = this.prixFournisseur
      this.demande.demandeLigneData.prixDetail = this.resultatCalculette.prixDetailRevise
      this.demande.demandeLigneData.devise = this.$store.getters.demande.infosFournisseur.informationEnlevement.devise
      this.demande.termeAchat = this.$store.getters.demande.termeAchat
      this.demande.demandeLigneData.pourcentageDepot = this.$store.getters.currentUser.infosClientJDE.coteABCAgent
      this.demande.demandeLigneData.nomProducteur = this.nomProducteur
      this.demande.demandeLigneData.marqueCommerciale = this.marqueCommerciale
      this.demande.demandeLigneData.nomCuvee = this.nomCuvee

      this.demande.demandeLigneData.codeNature = this.natureSelectionne.natureFamilleType.code
      this.demande.demandeLigneData.codeFamille = this.familleSelectionne.natureFamilleType.code
      this.demande.demandeLigneData.codeCouleur = this.couleur.couleur.code
      this.demande.demandeLigneData.codePays = this.paysSelectionne.paysRegion.code
      this.demande.commentaire = this.$store.getters.infosSupplementaire.commentaire
      this.demande.nomContactDemande = this.$store.getters.infosSupplementaire.nomContactDemande

      if (this.regionSelectionne.paysRegion != null) {
        this.demande.demandeLigneData.codeRegion = this.regionSelectionne.paysRegion.code
      }

      if (this.sousRegionSelectionne.paysRegion != null) {
        this.demande.demandeLigneData.codeSousRegion = this.sousRegionSelectionne.paysRegion.code
      }

      axios
        .post(`/demande/creerdemande`, this.demande)
        .then(response => {
          let resp = response.data
          let msg = null
          switch (resp.codeRetour) {
            case 'OK':
              this.demandeData = resp.resultat

              if (this.produitReconduction == false) {
                this.transmettreFichier()
              }

              this.afficherAjoutProduit = false

              break
            default:
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              this.$store.dispatch('afficherError', msg)
              break
          }
        })
        .catch(error => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
    },

    majNomProduit() {
      if (this.nomCuvee == null) {
        this.nomCuvee = ''
      }
      this.description = this.marqueCommerciale + ' ' + this.nomCuvee
    },

    ajoutProduit() {
      console.log('ajoutProduit')

      this.afficherAjoutProduit = true
      this.resultatCalculette = {}
      this.fichier = []
      this.nomFichier = null
      this.obtenirListePaysFrequent()
      this.obtenirListePays()
      this.obtenirListePaysLettreFr()
      this.majDonneesProduits()
      this.obtenirListeNature()
    },

    majDonneesProduits() {
      this.demande.demandeLigneData = {}
      this.demande.demandeLigneData.uniteMesure = 'MILLILITRE'
      this.nomProducteur = null
      this.marqueCommerciale = null
      this.nomCuvee = null
      this.format = null
      this.uvc = null
      this.nombreCaissesDemandees = null
      this.prixFournisseur = null
      this.prixDetail = null
      this.description = null
      this.contenant = null
      this.pourcentageAlcool = null
      this.couleur = null
      this.paysSelectionne = { paysRegion: {} }
      this.regionSelectionne = { paysRegion: {} }
      this.sousRegionSelectionne = { paysRegion: {} }
      this.natureSelectionne = { natureFamilleType: {} }
      this.familleSelectionne = { natureFamilleType: {} }
      this.typeSelectionne = { natureFamilleType: {} }
      this.demande.demandeLigneData.typeContenant = null
      this.demande.demandeLigneData.typeBouchon = null
      this.produitReconduction = false
    },

    annulerAjoutProduit() {
      console.log('annulerAjoutProduit')

      this.afficherAjoutProduit = false
      this.resultatCalculette = {}
      this.fichier = []
      this.nomFichier = null
      this.demande.demandeLigneData = {}
      this.paysSelectionne = { paysRegion: {} }
      this.regionSelectionne = { paysRegion: {} }
      this.sousRegionSelectionne = { paysRegion: {} }
      this.majDonneesProduits()
      this.produitReconduction = false
    },

    ajouterProduit() {
      console.log('ajouterProduit')

      this.demande.demandeFournisseurData.noFournisseurEnlevement = this.infosFournisseur.noClientJDE
      this.demande.demandeLigneData.prixDetail = this.resultatCalculette.prixDetailRevise
      this.demande.demandeLigneData.devise = this.$store.getters.demande.infosFournisseur.informationEnlevement.devise
      this.demande.demandeLigneData.pourcentageDepot = this.$store.getters.currentUser.infosClientJDE.coteABCAgent
      this.demande.demandeLigneData.nomProducteur = this.nomProducteur
      this.demande.demandeLigneData.marqueCommerciale = this.marqueCommerciale
      this.demande.demandeLigneData.nomCuvee = this.nomCuvee

      if (this.paysSelectionne.paysRegion != null) {
        this.demande.demandeLigneData.codePays = this.paysSelectionne.paysRegion.code
      }

      if (this.regionSelectionne.paysRegion != null) {
        this.demande.demandeLigneData.codeRegion = this.regionSelectionne.paysRegion.code
      }

      if (this.sousRegionSelectionne.paysRegion != null) {
        this.demande.demandeLigneData.codeSousRegion = this.sousRegionSelectionne.paysRegion.code
      }

      this.demande.demandeLigneData.codeCouleur = this.couleur.couleur.code

      axios
        .post(`/demande/ajoutproduit`, this.demande)
        .then(response => {
          let resp = response.data
          let msg = null
          switch (resp.codeRetour) {
            case 'OK':
              this.demandeData = resp.resultat
              this.transmettreFichier()
              this.afficherAjoutProduit = false
              this.demande.demandeLigneData = {}
              this.majDonneesProduits()

              break
            default:
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              this.$store.dispatch('afficherError', msg)
              break
          }
        })
        .catch(error => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
    },

    modifierProduitDemande() {
      console.log('modifierProduitDemande ' + this.demande.demandeLigneData.id)

      this.demande.demandeLigneData.nomProducteur = this.nomProducteur
      this.demande.demandeLigneData.marqueCommerciale = this.marqueCommerciale
      this.demande.demandeLigneData.nomCuvee = this.nomCuvee
      this.demande.demandeLigneData.description = this.description
      this.demande.demandeLigneData.codePays = this.paysSelectionne.paysRegion.code

      if (this.regionSelectionne.paysRegion != null) {
        this.demande.demandeLigneData.codeRegion = this.regionSelectionne.paysRegion.code
      }

      if (this.sousRegionSelectionne.paysRegion != null) {
        this.demande.demandeLigneData.codeSousRegion = this.sousRegionSelectionne.paysRegion.code
      }

      this.demande.demandeLigneData.codeCouleur = this.couleur.couleur.code
      this.demande.demandeLigneData.pourcentageAlcool = this.pourcentageAlcool
      this.demande.demandeLigneData.formatBtl = this.format
      this.demande.demandeLigneData.uvc = this.uvc
      this.demande.demandeLigneData.nombreCaissesDemandees = this.nombreCaissesDemandees

      this.demande.demandeLigneData.noDemande = this.demandeData.noDemande

      this.demande.demandeLigneData.prixDetail = this.resultatCalculette.prixDetailRevise
      this.demande.demandeLigneData.prixFournisseur = this.prixFournisseur
      this.demande.demandeLigneData.pourcentageDepot = this.$store.getters.currentUser.infosClientJDE.coteABCAgent

      axios
        .post(`/demande/modifierproduit`, this.demande.demandeLigneData)
        .then(response => {
          let resp = response.data
          let msg = null
          switch (resp.codeRetour) {
            case 'OK':
              this.demandeData = resp.resultat
              this.afficherAjoutProduit = false
              this.transmettreFichier()
              break
            default:
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              this.$store.dispatch('afficherError', msg)
              break
          }
        })
        .catch(error => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
    },

    modifierNombreCaisse(item) {
      axios
        .post(`/demande/modifiernombrecaisse`, item)
        .then(response => {
          let resp = response.data
          let msg = null
          switch (resp.codeRetour) {
            case 'OK':
              this.demandeData = resp.resultat
              break

            case 'V024':
              this.$store.dispatch(
                'afficherWarning',
                'Le montant minimum par produit est de 150 $ ou de 5 caisses'
              )
              break

            default:
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              this.$store.dispatch('afficherError', msg)
              break
          }
        })
        .catch(error => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
    },

    soumettreModicationsClients() {
      console.log('soumettreModicationsClients')

      axios
        .post(`/demande/soumettremodificationsclient`, this.demandeData)
        .then(response => {
          let resp = response.data
          let msg = null
          switch (resp.codeRetour) {
            case 'OK':
              this.afficherAjoutProduit = false
              this.demande.demandeLigneData = {}
              this.$router.push({ name: 'accueil' })
              break
            default:
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              this.$store.dispatch('afficherError', msg)
              break
          }
        })
        .catch(error => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
    },

    soumettreEnBrouillon() {
      console.log('soumettreEnBrouillon')

      axios
        .post(`/demande/soumettrebrouillon`, this.demandeData)
        .then(response => {
          let resp = response.data
          let msg = null
          switch (resp.codeRetour) {
            case 'OK':
              this.afficherAjoutProduit = false
              this.demande.demandeLigneData = {}
              this.$router.push({ name: 'accueil' })

              break
            default:
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              this.$store.dispatch('afficherError', msg)
              break
          }
        })
        .catch(error => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
    },

    soumettreDemande() {
      console.log('soumettreDemande ')

      if (this.isPeutPayerAvecCapacite() == false) {
        this.$store.dispatch(
          'afficherInfo',
          "La capacité financière n'est pas suffisante"
        )
        return
      }

      if (
        this.checkbox1 == false ||
        this.checkbox2 == false ||
        this.checkbox1 == null ||
        this.checkbox2 == null
      ) {
        this.$store.dispatch(
          'afficherInfo',
          'Les termes et conditions doivent être acceptés'
        )
        return
      }

      this.sending = true

      if (
        this.$store.getters.currentUser.clientData.indCapaciteFinanciere == true
      ) {
        this.demandeData.typeDepot = 'CAPACITE_FINANCIERE'
      }

      axios
        .post(`/demande/soumettredemande`, this.demandeData)
        .then(response => {
          let resp = response.data
          let msg = null
          switch (resp.codeRetour) {
            case 'OK':
              this.afficherAjoutProduit = false
              this.$router.push({
                name: 'demandeIPConfirmation',
                params: {
                  noDemande: this.demandeData.noDemande,
                  detailDemande: false
                }
              })
              break
            default:
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              this.$store.dispatch('afficherError', msg)
              break
          }
        })
        .catch(error => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
        .finally(() => {
          this.sending = false
        })
    },

    transmettreFichier() {
      console.log('transmettreFichiesaur')
      this.overlay = true
      const fichier = this.$refs.fichier.files[0]

      if (fichier != null) {
        if (this.demande.demandeLigneData.id == undefined) {
          this.demande.demandeLigneData.id = 0
        }

        axios({
          url: `/demande/${this.demandeData.noDemande}/${this.demande.demandeLigneData.id}/fichier?nomFichier=${this.fichier.name}`,
          method: 'post',
          data: this.fichier,
          headers: {
            'Content-Type': 'application/octet-stream'
          }
        })
          .then(response => {
            let resp = response.data
            let msgs = ''
            let res = null
            if (resp.codeRetour === 'OK') {
              console.log('Fichier ajouté avec succes')
              for (
                let i = 0;
                i < this.demandeData.listeDemandeLigneData.length;
                i++
              ) {
                if (
                  this.demande.demandeLigneData.id ==
                  this.demandeData.listeDemandeLigneData[i].id
                ) {
                  this.demandeData.listeDemandeLigneData[
                    i
                  ].nomFichier = this.fichier.name
                }
              }
            }
          })
          .catch(error => {
            console.log('error=' + error)
            let msg = this.$fmtAxiosErr(error)
            this.$store.dispatch('afficherError', msg)
          })
          .finally(() => {
            this.overlay = false
          })
      }
    },

    obtenirCapaciteFinanciere() {
      console.log('obtenirCapaciteFinanciere')

      axios
        .get(
          `/capacitefinanciere/pourclient/${this.$store.getters.currentUser.infosClientJDE.noClientJDE}`
        )
        .then(response => {
          let resp = response.data
          let msg = null
          switch (resp.codeRetour) {
            case 'OK':
              this.capaciteFinanciere = resp.resultat
              break
            case 'W001':
              break
            case 'X001':
              this.$store.dispatch(
                'afficherInfo',
                'Il y a un problème à récupérer les informations de votre capacité financière'
              )
              break
            case 'V016':
              this.capaciteFinanciere = 0
              break
            default:
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              this.$store.dispatch('afficherError', msg)
              break
          }
        })
        .catch(error => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
    },

    obtenirCategorieDepot() {
      console.log('obtenirCategorieDepot')
      axios
        .get(
          `/clients/obtenircategoriedepot/${this.$store.getters.currentUser.clientData.idDemandeur}`
        )
        .then(response => {
          let resp = response.data
          let msg = null
          switch (resp.codeRetour) {
            case 'OK':
              this.categorieDepot = resp.resultat
              break
            case 'V017':
              this.garantieBancaire = {}
              break
            default:
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              this.$store.dispatch('afficherError', msg)
              break
          }
        })
        .catch(error => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
    },

    obtenirDemande() {
      console.log('obtenirDemande ' + this.$route.params.noDemande)

      axios
        .get('/demande/obtenirDemande/' + this.$route.params.noDemande)
        .then(response => {
          let resp = response.data
          let msg = null
          switch (resp.codeRetour) {
            case 'OK':
              this.demandeData = resp.resultat
              this.rechercherFournisseur()
              break
            default:
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              this.$store.dispatch('afficherError', msg)
              break
          }
        })
        .catch(error => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
    },

    rechercherFournisseur() {
      console.log(
        'rechercherFournisseur' + this.$route.params.noFournisseurRecherche
      )
      this.sending = true

      if (this.$route.params.noFournisseurRecherche != null) {
        this.noFournisseurRecherche = this.$route.params.noFournisseurRecherche
      }

      if (isNaN(this.noFournisseurRecherche) == true) {
        this.$store.dispatch(
          'afficherInfo',
          'Le numéro du fournisseur ne doit comporter que des chiffres'
        )
        return
      }

      console.log('Demande chercher fournisseur ', this.noFournisseurRecherche)
      this.infosFournisseur.informationEnlevement = []
      this.infosFournisseur.informationsAdminstratives = []

      axios
        .get(
          `/fournisseurs/obtenirinfosfournisseurselonclient/${this.noFournisseurRecherche}/${this.$store.getters.currentUser.clientData.idDemandeur}`
        )
        .then(response => {
          let resp = response.data
          let msg = null
          switch (resp.codeRetour) {
            case 'OK':
              this.$store.getters.demande.infosFournisseur = resp.resultat
              this.obtenirDevise()
              this.obtenirListeProduitsSelonFournisseur()
              break
            case 'V015':
              this.$store.dispatch(
                'afficherInfo',
                "Ce fournisseur n'existe pas dans votre liste"
              )
              break
            case 'X001':
              this.$store.dispatch(
                'afficherInfo',
                'Il y a un problème à récupérer les informations du fournisseur'
              )
              break
            default:
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              this.$store.dispatch('afficherError', msg)
              break
          }
        })
        .catch(error => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
        .finally(() => {
          this.sending = false
        })
    },

    deviseFournisseur() {
      if (this.infosFournisseur.informationEnlevement.devise != null) {
        return this.infosFournisseur.informationEnlevement.devise
      } else if (
        this.infosFournisseur.informationsAdminstratives.devise != null
      ) {
        return this.infosFournisseur.informationsAdminstratives.devise
      }
    },

    obtenirDevise() {
      console.log('obtenirDevise ')

      var codeDevise = this.deviseFournisseur()

      axios
        .get(`/devise/${codeDevise}`)
        .then(response => {
          let resp = response.data
          let msg = null
          switch (resp.codeRetour) {
            case 'OK':
              this.$store.getters.demande.tauxDevise = resp.resultat
              break
            case 'W001':
              this.$store.dispatch(
                'afficherInfo',
                "Cette devise n'est pas une devise reconnue"
              )
              break
            default:
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              this.$store.dispatch('afficherError', msg)
              break
          }
        })
        .catch(error => {
          this.agents = []
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
    },

    obtenirListeProduitsSelonFournisseur() {
      if (this.infosFournisseur.informationEnlevement.length == 0) {
        this.$store.dispatch(
          'afficherInfo',
          'Vous devez sélectionner un fournisseur pour la liste de produits'
        )
        return
      }

      var noFournisseur
      if (this.infosFournisseur.informationEnlevement.noFournisseur != null) {
        noFournisseur = this.infosFournisseur.informationEnlevement
          .noFournisseur
      } else {
        noFournisseur = this.infosFournisseur.informationsAdminstratives
          .noFournisseur
      }

      console.log('obtenirListeProduitsSelonFournisseur ' + noFournisseur)

      axios
        .get(
          `/demande/obtenirDemandeProduit/${this.$store.getters.currentUser.clientData.idDemandeur}/${noFournisseur}`
        )
        .then(response => {
          let resp = response.data
          let msg = null
          switch (resp.codeRetour) {
            case 'OK':
              this.$store.getters.demande.listeProduits = resp.resultat
              break
            case 'W001':
              break
            default:
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              this.$store.dispatch('afficherError', msg)
              break
          }
        })
        .catch(error => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
    },

    isPeutPayerAvecCapacite() {
      console.log(
        'isPeutPayerAvecCapacite ' +
          this.capaciteFinanciere.montantCapacite +
          '  ' +
          this.demandeData.montantTotalDepot
      )
      if (
        this.capaciteFinanciere.montantCapacite >
        this.demandeData.montantTotalDepot
      ) {
        return true
      } else {
        return false
      }
    },

    versPageCapacite() {
      this.$router.push({ name: 'capaciteFinanciere' })
    },

    annuler() {
      this.$router.push({ name: 'accueil' })
    },

    obtenirListePaysFrequent() {
      axios
        .get(`/paysregion/paysfrequent`)
        .then(response => {
          let resp = response.data
          let msg = null
          switch (resp.codeRetour) {
            case 'OK':
              this.listePaysFrequents = resp.resultat

              this.listePaysFrequents.sort(function(a, b) {
                return a.paysRegion.fr.localeCompare(b.paysRegion.fr)
              })

              break
            default:
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              this.$store.dispatch('afficherError', msg)
              break
          }
        })
        .catch(error => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
    },

    obtenirListePays() {
      axios
        .get(`/paysregion/listepays`)
        .then(response => {
          let resp = response.data
          let msg = null
          switch (resp.codeRetour) {
            case 'OK':
              this.listePays = resp.resultat

              this.listePays.sort(function(a, b) {
                return a.paysRegion.fr.localeCompare(b.paysRegion.fr)
              })
              break
            default:
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              this.$store.dispatch('afficherError', msg)
              break
          }
        })
        .catch(error => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
    },

    obtenirListeNature() {
      axios
        .get(`/naturefamille/listenature`)
        .then(response => {
          let resp = response.data
          let msg = null
          switch (resp.codeRetour) {
            case 'OK':
              this.listeNature = resp.resultat

              this.listeNature.sort(function(a, b) {
                return a.natureFamilleType.fr.localeCompare(
                  b.natureFamilleType.fr
                )
              })
              break
            default:
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              this.$store.dispatch('afficherError', msg)
              break
          }
        })
        .catch(error => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
    },

    obtenirListeCouleur() {
      axios
        .get(`/naturefamille/listecouleur`)
        .then(response => {
          let resp = response.data
          let msg = null
          switch (resp.codeRetour) {
            case 'OK':
              this.listeCouleur = resp.resultat
              break
            default:
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              this.$store.dispatch('afficherError', msg)
              break
          }
        })
        .catch(error => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
    },

    obtenirListeFamilleSelonNature() {
      this.listeFamille = []

      console.log(
        'obtenirListeFamilleSelonNature ' +
          this.natureSelectionne.natureFamilleType.code
      )

      axios
        .get(
          `/naturefamille/obtenirfamille/${this.natureSelectionne.natureFamilleType.code}`
        )
        .then(response => {
          let resp = response.data
          let msg = null
          switch (resp.codeRetour) {
            case 'OK':
              this.listeFamille = resp.resultat
              this.initCouleur()
              break
            case 'W001':
              break
            default:
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              this.$store.dispatch('afficherError', msg)
              break
          }
        })
        .catch(error => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
    },

    obtenirTypeSelonFamille() {
      this.listeType = []

      console.log(
        'obtenirTypeSelonFamille' +
          this.familleSelectionne.natureFamilleType.code
      )

      axios
        .get(
          `/naturefamille/obtenirtype/${this.familleSelectionne.natureFamilleType.code}`
        )
        .then(response => {
          let resp = response.data
          let msg = null
          switch (resp.codeRetour) {
            case 'OK':
              this.listeType = resp.resultat
              break
            case 'W001':
              break
            default:
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              this.$store.dispatch('afficherError', msg)
              break
          }
        })
        .catch(error => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
    },

    initCouleur() {
      console.log('initCouleur ' + this.natureSelectionne.natureFamilleType.fr)

      this.listeCouleurSelonNature = []

      if (
        this.natureSelectionne.natureFamilleType.code == 'BI' ||
        this.natureSelectionne.natureFamilleType.code == 'BA' ||
        this.natureSelectionne.natureFamilleType.code == 'BP' ||
        this.natureSelectionne.natureFamilleType.code == 'CI' ||
        this.natureSelectionne.natureFamilleType.code == 'HY' ||
        this.natureSelectionne.natureFamilleType.code == 'SP'
      ) {
        for (let i = 0; i < this.listeCouleur.length; i++) {
          this.listeCouleurSelonNature.push(this.listeCouleur[i])
        }
      } else if (this.natureSelectionne.natureFamilleType.code == 'PO') {
        for (let i = 0; i < this.listeCouleur.length; i++) {
          if (
            this.listeCouleur[i].couleur.code == '01' ||
            this.listeCouleur[i].couleur.code == '04' ||
            this.listeCouleur[i].couleur.code == '61' ||
            this.listeCouleur[i].couleur.code == '64' ||
            this.listeCouleur[i].couleur.code == '03' ||
            this.listeCouleur[i].couleur.code == '02' ||
            this.listeCouleur[i].couleur.code == '01' ||
            this.listeCouleur[i].couleur.code == '00'
          ) {
            this.listeCouleurSelonNature.push(this.listeCouleur[i])
          }
        }
      } else if (this.natureSelectionne.natureFamilleType.code == 'SA') {
        for (let i = 0; i < this.listeCouleur.length; i++) {
          if (
            this.listeCouleur[i].couleur.code == '13' ||
            this.listeCouleur[i].couleur.code == '01' ||
            this.listeCouleur[i].couleur.code == '61' ||
            this.listeCouleur[i].couleur.code == '44' ||
            this.listeCouleur[i].couleur.code == '00'
          ) {
            this.listeCouleurSelonNature.push(this.listeCouleur[i])
          }
        }
      } else {
        for (let i = 0; i < this.listeCouleur.length; i++) {
          if (
            this.listeCouleur[i].couleur.code == '01' ||
            this.listeCouleur[i].couleur.code == '03' ||
            this.listeCouleur[i].couleur.code == '02' ||
            this.listeCouleur[i].couleur.code == '00'
          ) {
            this.listeCouleurSelonNature.push(this.listeCouleur[i])
          }
        }
      }
    },

    obtenirListePaysLettreFr() {
      axios
        .get(`/paysregion/listepayslettrefr`)
        .then(response => {
          let resp = response.data
          let msg = null
          switch (resp.codeRetour) {
            case 'OK':
              this.listePaysEtLettreFr = resp.resultat
              break
            default:
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              this.$store.dispatch('afficherError', msg)
              break
          }
        })
        .catch(error => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
    },

    initPays(item) {
      if (item != null) {
        console.log(
          'initPays ' +
            this.paysSelectionne +
            'item ' +
            item.fr +
            ' ' +
            item.code
        )

        this.paysSelectionne = { paysRegion: {} }

        if (this.paysSelectionne.paysRegion != null) {
          this.paysSelectionne.paysRegion.actif = true
          this.paysSelectionne.paysRegion.code = item.code.toString(2)
          this.paysSelectionne.paysRegion.fr = item.fr
          this.paysSelectionne.paysRegion.en = item.en
        }

        this.obtenirListeRegionSelonPays()
      }

      this.close()
    },

    obtenirListeRegionSelonPays() {
      this.listeRegion = []
      this.listeSousRegion = []

      var codePays
      if (this.paysSelectionne.paysRegion != null) {
        codePays = this.paysSelectionne.paysRegion.code
      } else {
        codePays = this.paysSelectionne
        this.paysSelectionne = { paysRegion: {} }
        this.paysSelectionne.paysRegion.code = codePays
      }

      console.log('obtenirListeRegionSelonPays ' + codePays)

      axios
        .get(`/paysregion/obtenirregion/${codePays}`)
        .then(response => {
          let resp = response.data
          let msg = null
          switch (resp.codeRetour) {
            case 'OK':
              this.listeRegion = resp.resultat
              break
            case 'W001':
              break
            default:
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              this.$store.dispatch('afficherError', msg)
              break
          }
        })
        .catch(error => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
    },

    obtenirListeSousRegionSelonRegion() {
      this.listeSousRegion = []

      axios
        .get(
          `/paysregion/obtenirsousregion/${this.regionSelectionne.paysRegion.code}`
        )
        .then(response => {
          let resp = response.data
          let msg = null
          switch (resp.codeRetour) {
            case 'OK':
              this.listeSousRegion = resp.resultat
              break
            case 'W001':
              this.listeSousRegion = []
              break
            default:
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              this.$store.dispatch('afficherError', msg)
              break
          }
        })
        .catch(error => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
    },

    close() {
      this.dialog = false
    },

    // Gestion fichiers
    clicAjouterFichier() {
      this.$refs.fichier.click()
    },

    uploadFichier() {
      console.log('uploadFichier')

      this.overlay = true
      this.fichier = this.$refs.fichier.files[0]
      this.$refs.fichier.value = null
    },

    supprimerFichier() {
      this.fichier = []
      this.nomFichier = null
    },

    soumettreAppelCalculette() {
      console.log('soumettreAppelCalculette')

      this.soumisCalculette = true

      if (
        this.infosFournisseur.informationsAdminstratives.noFournisseur == null
      ) {
        this.$store.dispatch(
          'afficherWarning',
          'Vous devez saisir un fournisseur'
        )
        return
      }

      if (this.$store.getters.currentUser.infosClientJDE.coteABCAgent == 0) {
        this.$store.dispatch(
          'afficherWarning',
          'Vous devez avoir un pourcentage de dépôt'
        )
        return
      }

      if (this.nomProducteur == null) {
        this.$store.dispatch(
          'afficherWarning',
          'Le nom du producteur est obligatoire'
        )
        return
      }

      if (this.marqueCommerciale == null) {
        this.$store.dispatch(
          'afficherWarning',
          'La marque commerciale est obligatoire'
        )
        return
      }

      if (this.description == null) {
        this.$store.dispatch(
          'afficherWarning',
          'Le nom du produit est obligatoire'
        )
        return
      }

      if (this.natureSelectionne.natureFamilleType.code == null) {
        this.$store.dispatch('afficherWarning', 'La nature est obligatoire')
        return
      }

      if (this.familleSelectionne.natureFamilleType.code == null) {
        this.$store.dispatch('afficherWarning', 'La famille est obligatoire')
        return
      }

      if (this.paysSelectionne.paysRegion.code == null) {
        this.$store.dispatch(
          'afficherWarning',
          "Le pays d'origine est obligatoire"
        )
        return
      }

      if (this.couleur == null) {
        this.$store.dispatch('afficherWarning', 'La couleur est obligatoire')
        return
      }

      if (this.pourcentageAlcool == null) {
        this.$store.dispatch(
          'afficherWarning',
          "Le pourcentage d'alcool est obligatoire"
        )
        return
      }

      if (this.format == null) {
        this.$store.dispatch('afficherWarning', 'Le format est obligatoire')
        return
      } else {
        this.demande.demandeLigneData.format = this.format
        this.demande.demandeLigneData.format = this.demande.demandeLigneData.format
          .toString()
          .replace(/\s/g, '')

        if (this.demande.demandeLigneData.format > 20000) {
          this.$store.dispatch(
            'afficherWarning',
            'Le maximum comme format est de 20 000 ml'
          )
          return
        }
      }

      if (this.uvc == null) {
        this.$store.dispatch(
          'afficherWarning',
          'Le nombre de bouteilles / caisse est obligatoire'
        )
        return
      }

      if (this.nombreCaissesDemandees == null) {
        this.$store.dispatch(
          'afficherWarning',
          'Le nombre de caisses commandées est obligatoire'
        )
        return
      }

      if (this.demande.demandeLigneData.typeContenant == null) {
        this.$store.dispatch(
          'afficherWarning',
          'Le type de contenant est obligatoire'
        )
        return
      }

      if (this.demande.demandeLigneData.typeBouchon == null) {
        this.$store.dispatch(
          'afficherWarning',
          'Le type de bouchon est obligatoire'
        )
        return
      }

      if (this.prixFournisseur == null) {
        this.$store.dispatch(
          'afficherWarning',
          'Le prix du fournisseur (à la caisse) est obligatoire'
        )
        return
      }

      if (this.pourcentageAlcool != null) {
        this.pourcentageAlcool = this.pourcentageAlcool
          .toString()
          .replace(',', '.')
      }

      if (this.format != null) {
        this.format = this.format.toString().replace(',', '.')
      }

      if (this.prixFournisseur != null) {
        this.prixFournisseur = this.prixFournisseur.toString().replace(',', '.')
      }

      this.resultatCalculette = {}

      this.demande.noDemande = this.demandeData.noDemande

      this.demande.demandeLigneData.devise = this.infosFournisseur.informationEnlevement.devise
      this.demande.demandeLigneData.pourcentageDepot = this.$store.getters.currentUser.infosClientJDE.coteABCAgent
      this.demande.demandeLigneData.nomProducteur = this.nomProducteur
      this.demande.demandeLigneData.marqueCommerciale = this.marqueCommerciale
      this.demande.demandeLigneData.nomCuvee = this.nomCuvee
      this.demande.demandeLigneData.codePays = this.paysSelectionne.paysRegion.code
      this.demande.demandeLigneData.codePostalFournisseur = this.infosFournisseur.informationEnlevement.codePostal
      this.demande.termeAchat = this.$store.getters.demande.termeAchat
      this.demande.demandeLigneData.provinceEtatFournisseur = this.infosFournisseur.informationEnlevement.provinceEtat
      this.demande.demandeLigneData.paysFournisseur = this.infosFournisseur.informationEnlevement.pays

      if (this.demandeData.noDemande != null) {
        this.demande.demandeLigneData.noDemande = this.demandeData.noDemande
      }

      if (this.regionSelectionne.paysRegion != null) {
        this.demande.demandeLigneData.codeRegion = this.regionSelectionne.paysRegion.code
      }

      if (this.sousRegionSelectionne.paysRegion != null) {
        this.demande.demandeLigneData.codeSousRegion = this.sousRegionSelectionne.paysRegion.code
      }

      this.demande.demandeLigneData.codeNature = this.natureSelectionne.natureFamilleType.code
      this.demande.demandeLigneData.codeFamille = this.familleSelectionne.natureFamilleType.code
      this.demande.demandeLigneData.codeCouleur = this.couleur.couleur.code

      this.demande.demandeLigneData.codeType = null
      if (this.typeSelectionne != null) {
        this.demande.demandeLigneData.codeType = this.typeSelectionne.natureFamilleType.code
      }

      this.demande.demandeLigneData.description = this.description
      this.demande.demandeLigneData.pourcentageAlcool = this.pourcentageAlcool
      this.demande.demandeLigneData.uvc = this.uvc
      this.demande.demandeLigneData.nombreCaissesDemandees = this.nombreCaissesDemandees
      this.demande.demandeLigneData.prixFournisseur = this.prixFournisseur

      this.appelCalculette()
    },

    appelCalculette() {
      console.log(
        'appelCalculette ',
        this.$store.getters.currentUser.infosClientJDE.noClientJDE
      )
      this.sending = true

      this.demande.clientData.noClientJDE = this.$store.getters.currentUser.infosClientJDE.noClientJDE

      axios
        .post(`/calculette`, this.demande)
        .then(response => {
          let resp = response.data
          let msg = null

          switch (resp.codeRetour) {
            case 'OK':
              this.demande = resp.resultat
              this.resultatCalculette = this.demande.resultatCalculette
              this.demande.noDemande = this.resultatCalculette.noDemande
              this.demandeData.noDemande = this.resultatCalculette.noDemande
              this.demande.demandeLigneData.id = this.resultatCalculette.noDemandeLigne
              this.demande.demandeLigneData.indNouvelleLigneProduit = this.resultatCalculette.indNouvelleLigneProduit

              if (this.resultatCalculette.prixDetailRevise == 0) {
                this.$store.dispatch(
                  'afficherWarning',
                  "Il n'est pas possible de calculer le prix pour le moment, cliquer sur le bouton  Sauvegarder le produit pour continuer"
                )
              }

              break
            case 'X001':
            case 'V200':
              console.log(
                'Pas eu appel a la calculette car une donnée est insuffisante'
              )
              if (this.demande.demandeLigneData.id == null) {
                this.demande.demandeLigneData.indNouvelleLigneProduit = true
              }

              this.$store.dispatch(
                'afficherWarning',
                "Il n'est pas possible de calculer le prix pour le moment, cliquer sur le bouton  Sauvegarder le produit pour continuer"
              )
              break
            default:
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              this.$store.dispatch('afficherError', msg)
              break
          }
        })
        .catch(error => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
        .finally(() => {
          this.sending = false
        })
    },

    setUpMoneris() {
      var myCheckout = new monerisCheckout()
      myCheckout.setMode(this.env)
      myCheckout.setCheckoutDiv('monerisCheckout')
      myCheckout.startCheckout(this.ticket)
      myCheckout.setCallback('page_loaded', this.myPageLoad)
      myCheckout.setCallback('cancel_transaction', this.myCancelTransaction)
      myCheckout.setCallback('error_event', this.myErrorEvent)
      myCheckout.setCallback('payment_receipt', this.myPaymentReceipt)
      myCheckout.setCallback('payment_complete', this.myPaymentComplete)
    },

    myPaymentComplete() {
      console.log('myPaymentComplete ' + this.ticket)
      this.effectuerPaiement()
    },
    myPageLoad() {
      console.log('myPageLoad')

      var parametre = location.search.split('retour=')[1]
      console.log('value : ' + parametre)
      this.resultatPaiement = parametre
    },
    myCancelTransaction() {
      console.log('myCancelTransaction')
      this.$router.push({ name: 'accueil' })
    },
    myErrorEvent() {
      console.log('myErrorEvent')

      this.$router.push({
        path: '/demandeIP',
        query: {
          retour: 'V100'
        },
        params: {
          retour: 'V100'
        }
      })
      this.myPageLoad()
      this.initCarteCredit()
    },
    myPaymentReceipt() {
      console.log('myPaymentReceipt noDemande:' + this.demandeData.noDemande)
      this.$router.push({
        name: 'demandeIPConfirmation',
        params: { noDemande: this.demandeData.noDemande }
      })
    },

    initCarteCredit() {
      console.log('initCarteCredit ')

      if (
        this.demandeData.noDemande &&
        this.demandeData.montantTotalDepot != null
      ) {
        axios
          .post(
            `/paiements/obtenirticketdepot/${this.$store.getters.currentUser.infosClientJDE.noClientJDE}/${this.demandeData.noDemande}/${this.demandeData.montantTotalDepot}`
          )
          .then(response => {
            let resp = response.data
            let msg = null
            switch (resp.codeRetour) {
              case 'OK':
                this.ticket = resp.resultat
                console.log('Ticket: ' + this.ticket)
                this.setUpMoneris()
                break

              case 'W001':
                break

              default:
                console.log(`erreur resp.codeRetour=${resp.codeRetour}`)
                this.$store.dispatch(
                  'afficherError',
                  `Une erreur technique est survenue (${resp.codeRetour} - ${resp.messages} )`
                )
                break
            }
          })
          .catch(error => {
            console.log('error=' + error)
            let msg = this.$fmtAxiosErr(error)
            this.$store.dispatch('afficherError', msg)
          })
      }
    },

    effectuerPaiement() {
      console.log('effectuerPaiement')

      //if (
      //  this.checkbox1 == false ||
      // this.checkbox2 == false ||
      // this.checkbox1 == null ||
      // this.checkbox2 == null
      //) {
      //  this.$store.dispatch(
      //    'afficherInfo',
      //    'Les termes et conditions doivent être acceptés'
      //  )
      // return
      // }

      axios
        .post(
          `/paiements/effectuerpaiement/${this.$store.getters.currentUser.clientData.idDemandeur}/${this.ticket}/${this.demandeData.noDemande}/depot`
        )
        .then(response => {
          let resp = response.data
          let msg = null
          switch (resp.codeRetour) {
            case 'OK':
              this.resultatPaiement = resp.resultat
              console.log('approbation ' + this.resultatPaiement)
              this.myPaymentReceipt()
              break

            case 'V100':
              this.resultatPaiement = resp.resultat
              this.myErrorEvent()
              break

            default:
              console.log(`erreur resp.codeRetour=${resp.codeRetour}`)
              this.$store.dispatch(
                'afficherError',
                `Une erreur technique est survenue (${resp.codeRetour} - ${resp.messages} )`
              )
              break
          }
        })
        .catch(error => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
    }
  }
}
</script>

<style scoped>
div {
  font-size: 14px;
}

span {
  font-size: 14px;
  color: black;
}

.v-input .v-label {
  font-size: 14px;
  color: black;
}

.lien {
  height: 28px;
  width: 26.01px;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.6);
  font-family: Roboto;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 28px;
}

.texteMessageErreur {
  font-weight: bold;
  font-size: 14px;
}

.container {
  width: calc(95%);

  border: none;
  border-radius: 4px;
}

#checkout-form {
  position: relative;
  width: calc(95%);
  padding: 10px;
}

#checkout-form label {
  display: block;
  min-height: 25px;

  font-size: 15px;
  font-weight: 500;

  padding: 0;
  color: red;
}

#card-number,
#card-cvv,
#card-expiry {
  background-color: #fff;
  display: block;
  width: calc(90%);
  border-radius: 2px;
  border: 1px solid rgba(200, 200, 200, 1);
  padding: 14px 60px 13px 20px;
  margin: auto;
  transition: all 100ms ease-out;
}

.v-text-field--outlined >>> fieldset {
  border-color: black;
  border-width: 1.5px;
}
</style>
